const baseUrl = process.env.REACT_APP_APT_API_URL;

export default {
    handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    },

    get(url, onSuccess, onError, token) {
        fetch(baseUrl + url,
            { headers: { 'Authorization': 'Bearer ' + token } }
        )
            .then(this.handleErrors)
            .then(response => response.json())
            .then(data => {
                if (onSuccess) {
                    onSuccess(data);
                }
            }).catch((error) => {
            if (onError) {
                onError();
            }
        });
    },

    delete(url, onSuccess, onError, token, body) {
        fetch(baseUrl + url, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: body,
            redirect: 'follow'
        })
            .then(response => {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json();
                } else {
                    return response.text();
                }
            })
            .then((data) => {
                if (onSuccess) {
                    onSuccess(data);
                }
            }).catch((error) => {
            if (onError) {
                onError();
            }
        });
    },

    post(url, body, onSuccess, onError, token, signal) {
        fetch(baseUrl + url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: body,
            redirect: 'follow',
            signal: signal,
        })
            .then(response => {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json();
                } else {
                    return response.text();
                }
            })
            .then(data => {
                if (onSuccess) {
                    onSuccess(data);
                }
            }).catch((error) => {
            if (onError && error.name !== "AbortError") {
                onError(error);
            }
        });
    },

    postForBlob(url, body, onSuccess, onError, token) {

        let filename;

        fetch(baseUrl + url, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: body,
            responseType: 'blob'
        })
            .then(function (response) {

                let contentDisposition = response.headers.get("Content-Disposition");

                let contentDispositionParts = contentDisposition.split(";");
                let filenameElement = contentDispositionParts.find(x => x.indexOf("filename=") > 0);

                if (filenameElement) {
                    filename = filenameElement.split("=")[1];
                }

                return response.blob();
            }).then(function (blob) {

            if (onSuccess) {
                onSuccess(blob, filename);
            }
        }).catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    },

    postForFileUpload(url, formData, onSuccess, onError, token, signal) {
        fetch(baseUrl + url, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: formData,
            redirect: 'follow',
            signal: signal,
        })
            .then(response => {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json();
                } else {
                    return response.text();
                }
            })
            .then(data => {
                if (onSuccess) {
                    onSuccess(data);
                }
            }).catch((error) => {
            if (onError && error.name !== "AbortError") {
                onError(error);
            }
        });
    },

    put(url, body, onSuccess, onError, token) {
        fetch(baseUrl + url, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: body,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(data => {

                if (data?.isError) {
                    if (onError) {
                        onError(data);
                    }
                } 
                else if (onSuccess) {
                    onSuccess(data);
                }
            }).catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    },

    patch(url, body, onSuccess, onError, token) {
        fetch(baseUrl + url, {
            method: 'PATCH',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token
            },
            body: body,
            redirect: 'follow'
        })
            .then(response => {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json();
                } else {
                    return response.text();
                }
            })
            .then(data => {
                if (data?.isError) {
                    if (onError) {
                        onError(data);
                    }
                } 
                else if (onSuccess) {
                    onSuccess(data);
                }
            })
            .catch((error) => {
                if (onError) {
                    onError({
                        isError: true,
                        errorMessage: error.message
                    });
                }
            });
    },

    getUser(onSuccess, onError, token) {
        this.get('/user', onSuccess, onError, token);
    },

    getUserById(onSuccess, onError, userId, token) {
        this.get(`/users/${userId}`, onSuccess, onError, token);
    },

    removeUser(onSuccess, onError, userId, orgId, token) {
        this.delete('/users/' + userId + '/organisations/' + orgId, onSuccess, onError, token);
    },

    getEnums(onSuccess, onError, token) {
        this.get('/enums', onSuccess, onError, token);
    },

    getUsers(onSuccess, onError, query, pageNumber, pageSize, orgId, token) {
        let body = JSON.stringify({
            "organisationId": orgId,
            "pageNumber": pageNumber,
            "pageSize": pageSize,
            "query": query
        });
        this.post('/users/search', body, onSuccess, onError, token);
    },

    editUser(onSuccess, onError, first, last, userId, token) {

        let body = JSON.stringify({
            "firstName": first,
            "lastName": last
        });

        this.put('/users/' + userId, body, onSuccess, onError, token);
    },

    editUserRole(onSuccess, onError, first, last, userId, role, clientIds, siteIds, siteGroupIds, maximumCancellationsPerMonth, maximumNumberOfAllowListEntries, reportIds, payments, allowApiAccess, vehicleAnalytics, wardenNumber, orgId, token) {

        let body = JSON.stringify({
            "firstName": first,
            "lastName": last,
            "organisationId": orgId,
            "role": role,
            clientIds,
            "siteIds": siteIds,
            "siteGroupIds": siteGroupIds,
            "maximumCancellationsPerMonth": maximumCancellationsPerMonth,
            maximumNumberOfAllowListEntries,
            reportIds,
            payments,
            "allowApiAccess": allowApiAccess,
            vehicleAnalytics,
            wardenNumber
        });

        this.put('/users/' + userId, body, onSuccess, onError, token);
    },

    getNumberRanges(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/reference-number-ranges', onSuccess, onError, token);
    },

    getNumberRange(onSuccess, onError, rangeId, orgId, token) {
        this.get('/' + orgId + '/reference-number-ranges/' + rangeId, onSuccess, onError, token);
    },

    addNewNumberRange(onSuccess, onError, prefix, start, minDigits, isActive, type, orgId, token) {

        let body = JSON.stringify({
            "contraventionType": type,
            "prefix": prefix,
            "start": start,
            "minimumDisplayDigits": minDigits,
            "isActive": isActive,
        });

        this.put('/' + orgId + '/reference-number-ranges/add', body, onSuccess, onError, token);
    },

    editNumberRange(onSuccess, onError, prefix, start, minDigits, isActive, type, rangeId, orgId, token) {

        let body = JSON.stringify({
            "contraventionType": type,
            "prefix": prefix,
            "start": start,
            "minimumDisplayDigits": minDigits,
            "isActive": isActive,
        });

        this.put('/' + orgId + '/reference-number-ranges/' + rangeId, body, onSuccess, onError, token);
    },

    getOrganisations(onSuccess, onError, token) {
        this.get('/organisations', onSuccess, onError, token);
    },

    getOrganisation(onSuccess, onError, orgId, token) {
        this.get('/organisations/' + orgId, onSuccess, onError, token);
    },

    addOrganisation(onSuccess, onError, organisationName, debtCollectionMethod, status, shardName, addressLine1, addressLine2, addressLine3, postCode, townOrCity, emailAddress, mobileNumber, contactName, phoneNumber, allowApiAccess, token) {
        let body = JSON.stringify({
            "name": organisationName,
            "isActive": status,
            "shardName": shardName,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "postCode": postCode,
            "townOrCity": townOrCity,
            "contactEmailAddress": emailAddress,
            "contactMobileNumber": mobileNumber,
            "contactPhoneNumber": phoneNumber,
            "contactName": contactName,
            "allowApiAccess": allowApiAccess
        });

        this.put('/organisations/add', body, onSuccess, onError, token);
    },

    editOrganisation(onSuccess, onError, organisationName, debtCollectionMethod, status, addressLine1, addressLine2, addressLine3, postCode, townOrCity, emailAddress, mobileNumber, contactName, phoneNumber, allowApiAccess, orgId, token) {

        let body = JSON.stringify({
            "name": organisationName,
            "isActive": status,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "postCode": postCode,
            "townOrCity": townOrCity,
            "contactEmailAddress": emailAddress,
            "contactMobileNumber": mobileNumber,
            "contactPhoneNumber": phoneNumber,
            "contactName": contactName,
            "allowApiAccess": allowApiAccess
        });

        this.put('/organisations/' + orgId, body, onSuccess, onError, token);
    },

    getClients(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/clients', onSuccess, onError, token);
    },

    addClient(onSuccess, onError, name, type, companyAddress, postCode, townOrCity, county, country, status, companyEmailAddress, companyPhoneNumber, emailAddress, mobileNumber, contactFirstName, contactLastName, jobTitle, phoneNumber, parkfolioUsername, parkfolioPassword, flowbirdApiUsername, flowbirdApiPassword, maximumCancellationsPerMonth, isPortalEnabled, maximumCancellationDays, cancellableBreachStatuses, orgId, token) {

        let body = JSON.stringify({
            "name": name,
            "clientType": type,
            "addressLine1": companyAddress,
            "postCode": postCode,
            "townOrCity": townOrCity,
            "county": county,
            "country": country,
            "isActive": status,
            "companyEmailAddress": companyEmailAddress,
            "companyPhoneNumber": companyPhoneNumber,
            "primaryContactEmail": emailAddress,
            "primaryContactMobile": mobileNumber,
            "primaryContactFirstName": contactFirstName,
            "primaryContactSurname": contactLastName,
            "primaryContactJobTitle": jobTitle,
            "primaryContactPhoneNumber": phoneNumber,
            "parkfolioUsername": parkfolioUsername,
            "parkfolioPassword": parkfolioPassword,
            flowbirdApiUsername,
            flowbirdApiPassword,
            maximumCancellationsPerMonth,
            "isPortalEnabled": isPortalEnabled,
            maximumCancellationDays,
            cancellableBreachStatuses
        });

        this.put('/' + orgId + "/clients/add", body, onSuccess, onError, token);
    },

    getSingleClient(onSuccess, onError, orgId, clientId, token) {
        this.get('/' + orgId + '/clients/' + clientId, onSuccess, onError, token);
    },

    deleteClient(onSuccess, orgId, clientId, token) {
        this.delete('/' + orgId + '/clients/' + clientId, onSuccess, null, token);
    },

    editClient(onSuccess, onError, name, type, companyAddress, postCode, townOrCity, county, country, status, companyEmailAddress, companyPhoneNumber, emailAddress, mobileNumber, contactFirstName, contactLastName, jobTitle, phoneNumber, parkfolioUsername, parkfolioPassword, flowbirdApiUsername, flowbirdApiPassword, maximumCancellationsPerMonth, isPortalEnabled, maximumCancellationDays, cancellableBreachStatuses, orgId, clientId, token) {

        let body = JSON.stringify({
            "name": name,
            "clientType": type,
            "addressLine1": companyAddress,
            "postCode": postCode,
            "townOrCity": townOrCity,
            "county": county,
            "country": country,
            "isActive": status,
            "companyEmailAddress": companyEmailAddress,
            "companyPhoneNumber": companyPhoneNumber,
            "primaryContactEmail": emailAddress,
            "primaryContactMobile": mobileNumber,
            "primaryContactFirstName": contactFirstName,
            "primaryContactSurname": contactLastName,
            "primaryContactJobTitle": jobTitle,
            "primaryContactPhoneNumber": phoneNumber,
            "parkfolioUsername": parkfolioUsername,
            "parkfolioPassword": parkfolioPassword,
            flowbirdApiUsername,
            flowbirdApiPassword,
            maximumCancellationsPerMonth,
            "isPortalEnabled": isPortalEnabled,
            maximumCancellationDays,
            cancellableBreachStatuses,
        });

        this.put('/' + orgId + "/clients/" + clientId, body, onSuccess, onError, token);
    },

    getClientNotes(onSuccess, onError, orgId, clientId, token) {
        this.get('/' + orgId + '/clients/' + clientId + '/notes', onSuccess, onError, token);
    },

    addClientNote(onSuccess, onError, note, orgId, clientId, token) {

        let body = JSON.stringify({
            "note": note,
        });

        this.put('/' + orgId + "/clients/" + clientId + '/notes/add', body, onSuccess, onError, token);
    },

    getBreaches(onSuccess, onError, query, siteIds, userId, isAssigned, fromDate, toDate, contraventionType, breachStatuses, isOnHold, pageNumber, outputFormat, contraventionId, neverHadBreachStatuses, everHadBreachStatuses, minReceivedDaysAgo, maxReceivedDaysAgo, tagIds, orgId, token, signal) {
        var raw = JSON.stringify({
            query,
            "isAssigned": isAssigned,
            "siteIds": siteIds,
            "assignedToUserId": userId,
            "fromDate": fromDate,
            "toDate": toDate,
            "contraventionType": contraventionType,
            "breachStatuses": breachStatuses,
            "pageNumber": pageNumber,
            "isOnHold": isOnHold,
            "outputFormat": outputFormat,
            contraventionId,
            neverHadBreachStatuses,
            everHadBreachStatuses,
            minReceivedDaysAgo,
            maxReceivedDaysAgo,
            tagIds
        });
        if (outputFormat === 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append('Authorization', 'Bearer ' + token);


            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
            if (signal !== null) {
                requestOptions.signal = signal
            } else {
                if (_dashSearchAbortController) {
                    _dashSearchAbortController.abort()
                };

                _dashSearchAbortController = new AbortController()
                requestOptions.signal = _dashSearchAbortController.signal;
            }

            fetch(baseUrl + '/' + orgId + "/breaches/search", requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (onSuccess) {
                        onSuccess(data);
                    }
                }).catch((error) => {
                if (onError && error.name !== "AbortError") {
                    onError(error);
                }
            });
        } else {
            this.postForBlob(`/${orgId}/breaches/search`, raw, onSuccess, onError, token)
        }

    },

    unassignBreaches(organisationId, breaches, onSuccess, onError, token) {
        this.post(`/${organisationId}/breaches/unassign`, JSON.stringify({breachIds: breaches}), onSuccess, onError, token)
    },

    deleteBreaches(organisationId, breachIds, onSuccess, onError, token) {
        let body = JSON.stringify({breachIds});
        this.delete(`/${organisationId}/breaches`, onSuccess, onError, token, body)
    },

    getBreach(onSuccess, onError, breachId, orgId, token) {
        this.get('/' + orgId + '/breaches/' + breachId, onSuccess, onError, token);
    },

    getBreachPayments(onSuccess, onError, breachId, orgId, token) {
        this.get('/' + orgId + '/breaches/' + breachId + '/payments', onSuccess, onError, token);
    },

    addBreachPayment(onSuccess, onError, breachId, amount, reference, note, orgId, token) {
        this.put(`/${orgId}/breaches/${breachId}/payments/add`, JSON.stringify({
            amount,
            reference,
            note
        }), onSuccess, onError, token);
    },

    deleteBreachPayment(organisationId, breachId, breachPaymentId, token, onSuccess, onError) {
        this.delete(`/${organisationId}/breaches/${breachId}/payments/${breachPaymentId}`, onSuccess, onError, token);
    },

    getAdditionalCharges(onSuccess, onError, breachId, orgId, token) {
        this.get(`/${orgId}/breaches/${breachId}/additional-charges`, onSuccess, onError, token)
    },

    addAdditionalCharge(onSuccess, onError, breachId, amount, description, orgId, token) {
        let body = JSON.stringify({
            amount,
            description
        });
        this.post(`/${orgId}/breaches/${breachId}/additional-charges`, body, onSuccess, onError, token)
    },

    editAdditionalCharge(onSuccess, onError, breachId, additionalChargeId, amount, description, orgId, token) {
        let body = JSON.stringify({
            amount,
            description
        });
        this.put(`/${orgId}/breaches/${breachId}/additional-charges/${additionalChargeId}`, body, onSuccess, onError, token)
    },

    deleteAdditionalCharge(onSuccess, onError, breachId, additionalChargeId, orgId, token) {
        this.delete(`/${orgId}/breaches/${breachId}/additional-charges/${additionalChargeId}`, onSuccess, onError, token)
    },

    addWardenBreach(onSuccess, onError, siteId, vrm, vehicleColour, vehicleMake, vehicleModel, contraventionId, attachmentIds, startDate, endDate, orgId, token) {

        let body = JSON.stringify({
            contraventionId,
            siteId,
            vrm,
            vehicleMake,
            vehicleModel,
            vehicleColour,
            attachmentIds,
            startDate,
            endDate
        });

        this.put('/' + orgId + "/breaches/add", body, onSuccess, onError, token);
    },

    addBreachAttachment(onSuccess, attachmentId, breachId, orgId, token) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append('Authorization', 'Bearer ' + token);

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(baseUrl + '/' + orgId + "/breaches/" + breachId + '/attachments/' + attachmentId, requestOptions)
            .then(data => {
                if (onSuccess) {
                    onSuccess(data);
                }
            }).catch(error => console.log('error', error));
    },

    deleteBreachAttachment(onSuccess, onError, breachId, attachmentId, organisationId, token) {
        this.delete(`/${organisationId}/breaches/${breachId}/attachments/${attachmentId}`, onSuccess, onError, token)
    },

    getBreachAttachments(onSuccess, onError, orgId, breachId, token) {
        this.get('/' + orgId + '/breaches/' + breachId + '/attachments', onSuccess, onError, token);
    },

    setBreachAttachmentIsLetterImage(onSuccess, onError, orgId, breachId, attachmentId, isLetterImage, token) {
        this.put(`/${orgId}/breaches/${breachId}/attachments/${attachmentId}/set-letter-image`, JSON.stringify({
            isLetterImage
        }), onSuccess, onError, token);
    },

    setReadyForLetters(onSuccess, onError, note, breachId, orgId, token) {

        let body = JSON.stringify({
            "note": note,
        });

        this.post('/' + orgId + "/breaches/" + breachId + '/ready-to-send-letters', body, onSuccess, onError, token);
    },

    getSites(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/sites', onSuccess, onError, token);
    },

    searchSites(onSuccess, onError, query, pageNumber, clientId, sortBy, sortDirection, tagIds, orgId, token, signal) {
        var raw = JSON.stringify({
            query,
            pageNumber,
            clientId,
            sortBy,
            sortDirection,
            tagIds
        });

        this.post('/' + orgId + "/sites/search", raw, onSuccess, onError, token, signal);
    },

    getClientSites(onSuccess, onError, clientId, orgId, token) {
        this.get('/' + orgId + '/clients/' + clientId + '/sites', onSuccess, onError, token);
    },

    getSite(onSuccess, onError, siteId, orgId, token) {
        this.get('/' + orgId + '/sites/' + siteId, onSuccess, onError, token);
    },

    getAllSitesSummaries(onSuccess, onError, query, from, to, contraventionType, breachStatuses, everHadBreachStatuses, isOnHold, isAssigned, contraventionId, neverHadBreachStatuses, tagIds, orgId, token) {
        const body = JSON.stringify({
            "query": query,
            "from": from,
            "to": to,
            "contraventionType": contraventionType,
            "breachStatuses": breachStatuses,
            "isOnHold": isOnHold,
            "isAssigned": isAssigned,
            contraventionId,
            neverHadBreachStatuses,
            everHadBreachStatuses,
            tagIds
        })
        this.post('/' + orgId + '/breaches/search/summary', body, onSuccess, onError, token);
    },

    addSite(onSuccess, onError, name, siteCode, iasIpcCode, status, jurisdiction, addressLine1, addressLine2, addressLine3, postCode, townOrCity, iasEnabled, bpaEnabled, bpaCode, pofaEnabled, anprEnabled, maxAllowedParkingDuration, considerationPeriod, allowListEntryGrace, allowListExitGrace, allowListDurationGrace, contraventionsForOverStay, contraventionsForNotOnAllowList, contraventionsForShortReturn,
            parkingSessionLimit, noReturnWithin, contractExpiry, payAndDisplaySpaces, preAllocatedSpaces, disabledSpaces, permitSpaces, otherSpaces, permitPrefix, parkonomySiteCode, ringGoZone, payByPhoneLocationId, justParkLocationId, tap2ParkLocationId, parkBunnyLocationId, ipsLocationId, conviousLocationId, contraventionsForOverStayPaymentPeriodId,
            contraventionsForFailToPayId, isPayDisplay, overnightStayContraventionId, overnightStayStartTime, overnightStayEndTime, overnightStayGraceMinutes, maximumCancellationsPerMonth, autoAssignUserId, vehicleAnalyticsEnabled, regionId, lookingForCarParkLocationId, newParkLocationId, parksoLocationId, freeParkingMinutes, myCarPassLocationId, preventDuplicateBreaches, debtCollectionProviderId, orgId, clientId, token) {

        let body = JSON.stringify({
            "name": name,
            "siteCode": siteCode,
            "iasEnabled": iasEnabled,
            "iasCode": iasIpcCode,
            "bpaEnabled": bpaEnabled,
            "bpaCode": bpaCode,
            "pofaEnabled": pofaEnabled,
            "permitPrefix": permitPrefix,
            "parkonomySiteCode": parkonomySiteCode,
            "ringGoZone": ringGoZone,
            payByPhoneLocationId,
            justParkLocationId,
            tap2ParkLocationId,
            parkBunnyLocationId,
            ipsLocationId,
            conviousLocationId,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "townOrCity": townOrCity,
            "postCode": postCode,
            "status": status,
            "clientId": clientId,
            "contractExpiry": contractExpiry,
            "isActive": status,
            "isAnprEnabled": anprEnabled,
            "maxAllowedParkingDurationMinutes": maxAllowedParkingDuration,
            "considerationPeriodMinutes": considerationPeriod,
            "allowListEntryGraceMinutes": allowListEntryGrace,
            "allowListExitGraceMinutes": allowListExitGrace,
            "allowListDurationGraceMinutes": allowListDurationGrace,
            "noReturnWithinMinutes": noReturnWithin,
            "enforcementLimitMinutes": parkingSessionLimit,
            "overstayContraventionId": contraventionsForOverStay,
            "notOnAllowListContraventionId": contraventionsForNotOnAllowList,
            "shortReturnContraventionId": contraventionsForShortReturn,
            "payAndDisplaySpaces": payAndDisplaySpaces,
            "preAllocatedSpaces": preAllocatedSpaces,
            "disabledSpaces": disabledSpaces,
            "permitSpaces": permitSpaces,
            "otherSpaces": otherSpaces,
            "failedToMakePaymentContraventionId": contraventionsForFailToPayId,
            "overstayedPaymentPeriodContraventionId": contraventionsForOverStayPaymentPeriodId,
            "isPayAndDisplayEnabled": isPayDisplay,
            "overnightStayContraventionId": overnightStayContraventionId,
            "overnightStayStartTime": overnightStayStartTime,
            "overnightStayEndTime": overnightStayEndTime,
            "overnightStayGraceMinutes": overnightStayGraceMinutes,
            "maximumCancellationsPerMonth": maximumCancellationsPerMonth,
            autoAssignUserId,
            vehicleAnalyticsEnabled,
            regionId,
            lookingForCarParkLocationId,
            newParkLocationId,
            parksoLocationId,
            freeParkingMinutes,
            jurisdiction,
            myCarPassLocationId,
            preventDuplicateBreaches,
            debtCollectionProviderId
        });

        this.put('/' + orgId + "/sites/add", body, onSuccess, onError, token);
    },

    editSite(onSuccess, onError, name, siteCode, iasIpcCode, status, jurisdiction, addressLine1, addressLine2, addressLine3, postCode, townOrCity, iasEnabled, bpaEnabled, bpaCode, pofaEnabled, anprEnabled, maxAllowedParkingDuration, considerationPeriod, allowListEntryGrace, allowListExitGrace, allowListDurationGrace, contraventionsForOverStay, contraventionsForNotOnAllowList, contraventionsForShortReturn,
             parkingSessionLimit, noReturnWithin, contractExpiry, payAndDisplaySpaces, preAllocatedSpaces, disabledSpaces, permitSpaces, otherSpaces, permitPrefix, parkonomySiteCode, ringGoZone, payByPhoneLocationId, justParkLocationId, tap2ParkLocationId, parkBunnyLocationId, ipsLocationId, conviousLocationId, contraventionsForOverStayPaymentPeriodId,
             contraventionsForFailToPayId, isPayDisplay, overnightStayContraventionId, overnightStayStartTime, overnightStayEndTime, overnightStayGraceMinutes, maximumCancellationsPerMonth, autoAssignUserId, vehicleAnalyticsEnabled, regionId, lookingForCarParkLocationId, newParkLocationId, parksoLocationId, freeParkingMinutes, myCarPassLocationId, preventDuplicateBreaches, enforceShortReturnForAllowListEntries, debtCollectionProviderId, orgId, siteId, clientId, token) {

        var contractExpirySubmit = null;
        if (contractExpiry !== "") {
            contractExpirySubmit = contractExpiry;
        }

        let body = JSON.stringify({
            "name": name,
            "clientId": clientId,
            "siteCode": siteCode,
            "permitPrefix": permitPrefix,
            "parkonomySiteCode": parkonomySiteCode,
            "ringGoZone": ringGoZone,
            "payByPhoneLocationId": payByPhoneLocationId,
            "justParkLocationId": justParkLocationId,
            "tap2ParkLocationId": tap2ParkLocationId,
            "parkBunnyLocationId": parkBunnyLocationId,
            "iasEnabled": iasEnabled,
            "contractExpiry": contractExpirySubmit,
            "iasCode": iasIpcCode,
            "bpaEnabled": bpaEnabled,
            "bpaCode": bpaCode,
            "pofaEnabled": pofaEnabled,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "townOrCity": townOrCity,
            "postCode": postCode,
            "isActive": status,
            "isAnprEnabled": anprEnabled,
            "maxAllowedParkingDurationMinutes": maxAllowedParkingDuration,
            "considerationPeriodMinutes": considerationPeriod,
            "allowListEntryGraceMinutes": allowListEntryGrace,
            "allowListExitGraceMinutes": allowListExitGrace,
            "allowListDurationGraceMinutes": allowListDurationGrace,
            "noReturnWithinMinutes": noReturnWithin,
            "enforcementLimitMinutes": parkingSessionLimit,
            "overstayContraventionId": contraventionsForOverStay,
            "notOnAllowListContraventionId": contraventionsForNotOnAllowList,
            "shortReturnContraventionId": contraventionsForShortReturn,
            "payAndDisplaySpaces": payAndDisplaySpaces,
            "preAllocatedSpaces": preAllocatedSpaces,
            "disabledSpaces": disabledSpaces,
            "permitSpaces": permitSpaces,
            "otherSpaces": otherSpaces,
            "failedToMakePaymentContraventionId": contraventionsForFailToPayId,
            "overstayedPaymentPeriodContraventionId": contraventionsForOverStayPaymentPeriodId,
            "isPayAndDisplayEnabled": isPayDisplay,
            "overnightStayContraventionId": overnightStayContraventionId,
            "overnightStayStartTime": overnightStayStartTime,
            "overnightStayEndTime": overnightStayEndTime,
            "overnightStayGraceMinutes": overnightStayGraceMinutes,
            "maximumCancellationsPerMonth": maximumCancellationsPerMonth,
            autoAssignUserId,
            ipsLocationId,
            conviousLocationId,
            vehicleAnalyticsEnabled,
            regionId,
            lookingForCarParkLocationId,
            newParkLocationId,
            parksoLocationId,
            freeParkingMinutes,
            jurisdiction,
            myCarPassLocationId,
            preventDuplicateBreaches,
            enforceShortReturnForAllowListEntries,
            debtCollectionProviderId
        });

        this.put('/' + orgId + "/sites/" + siteId, body, onSuccess, onError, token);
    },

    deleteSite(onSuccess, orgId, siteId, token) {
        this.delete('/' + orgId + '/sites/' + siteId, onSuccess, null, token);
    },

    copySite(onSuccess, onError, siteId, name, clientId, orgId, token) {
        let body = JSON.stringify({
            name,
            clientId
        });
        this.post(`/${orgId}/sites/${siteId}/copy`, body, onSuccess, onError, token)
    },

    getSiteNotes(onSuccess, onError, orgId, siteId, token) {
        this.get('/' + orgId + '/sites/' + siteId + '/notes', onSuccess, onError, token);
    },

    addSiteNote(onSuccess, onError, note, orgId, siteId, token) {

        let body = JSON.stringify({
            "note": note,
        });

        this.put('/' + orgId + "/sites/" + siteId + '/notes/add', body, onSuccess, onError, token);
    },

    getSiteAttachments(onSuccess, onError, orgId, siteId, token) {
        this.get('/' + orgId + '/sites/' + siteId + '/attachments', onSuccess, onError, token);
    },

    addSiteAttachment(onSuccess, onError, fileId, validFrom, validTo, orgId, siteId, token) {
        let body = JSON.stringify({
            validFrom,
            validTo,
        })

        this.put('/' + orgId + "/sites/" + siteId + '/attachments/' + fileId, body, onSuccess, onError, token);
    },

    editSiteAttachment(onSuccess, onError, fileId, validFrom, validTo, orgId, siteId, token) {
        let body = JSON.stringify({
            validFrom,
            validTo,
        })

        this.patch('/' + orgId + "/sites/" + siteId + '/attachments/' + fileId, body, onSuccess, onError, token);
    },

    deleteSiteAttachment(onSuccess, onError, attachmentId, orgId, siteId, token) {
        this.delete(`/${orgId}/sites/${siteId}/attachments/${attachmentId}`, onSuccess, onError, token)
    },

    getAllSiteContraventions(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/sites/contraventions', onSuccess, onError, token);
    },

    getSiteContraventions(onSuccess, onError, orgId, siteId, token) {
        this.get('/' + orgId + '/sites/' + siteId + '/contraventions', onSuccess, onError, token);
    },

    editSiteContravention(onSuccess, onError, contraventionId, reducedChargeAmount, reducedChargeDays, fullChargeAmount, fullChargeDays, status, organisationId, siteId, token) {

        let body = JSON.stringify({
            "reducedChargeAmount": reducedChargeAmount,
            "reducedChargeDays": reducedChargeDays,
            "fullChargeAmount": fullChargeAmount,
            "fullChargeDays": fullChargeDays,
            "isActive": status,
        });

        this.put('/' + organisationId + "/sites/" + siteId + '/contraventions/' + contraventionId, body, onSuccess, onError, token);
    },

    getAllowListCreatedBy(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/allowed-vrms/created-by`, onSuccess, onError, token)
    },

    getAllowList(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/allowed-vrms', onSuccess, onError, token);
    },

    deleteMultipleAllowListVrms(onSuccess, onError, orgId, vrms, token) {
        let body = JSON.stringify({
            "vrms": vrms,
        });
        this.delete('/' + orgId + '/allowed-vrms', onSuccess, onError, token, body);
    },

    getAllowedVrm(onSuccess, onError, orgId, vrmId, token) {
        this.get('/' + orgId + '/allowed-vrms/' + vrmId, onSuccess, onError, token);
    },

    addAllowedVrm(onSuccess, onError, vrm, vehicleMake, vehicleModel, vehicleColour, reference, driverName, driverMobileNumber, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday, reason, siteId, clientId, anprCameraId, roi, siteGroupId, blueBadgeNumber, blueBadgeExpiryDate, maxStayMinutes, noReturnWithinMinutes, orgId, token) {

        let body = JSON.stringify({
            "vrm": vrm,
            "vehicleMake": vehicleMake,
            "vehicleModel": vehicleModel,
            "vehicleColour": vehicleColour,
            reference,
            "driverName": driverName,
            "driverMobileNumber": driverMobileNumber,
            "startDate": startDate,
            "endDate": endDate,
            "siteId": siteId,
            "clientId": clientId,
            anprCameraId,
            roi,
            siteGroupId,
            "notes": reason,
            enabledFromTime,
            enabledToTime,
            monday, tuesday, wednesday, thursday, friday, saturday, sunday,
            blueBadgeNumber,
            blueBadgeExpiryDate,
            maxStayMinutes, 
            noReturnWithinMinutes
        });

        this.put('/' + orgId + "/allowed-vrms/add", body, onSuccess, onError, token);
    },

    editAllowedVrm(onSuccess, onError, vrm, vehicleMake, vehicleModel, vehicleColour, reference, driverName, driverMobileNumber, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday, reason, siteId, clientId, anprCameraId, roi, siteGroupId, blueBadgeNumber, blueBadgeExpiryDate, maxStayMinutes, noReturnWithinMinutes, orgId, vrmId, token) {

        let body = JSON.stringify({
            "vrm": vrm,
            "vehicleMake": vehicleMake,
            "vehicleModel": vehicleModel,
            "vehicleColour": vehicleColour,
            reference,
            "driverName": driverName,
            "driverMobileNumber": driverMobileNumber,
            "startDate": startDate,
            "endDate": endDate,
            "siteId": siteId,
            "clientId": clientId,
            anprCameraId,
            roi,
            siteGroupId,
            "notes": reason,
            enabledFromTime,
            enabledToTime,
            monday, tuesday, wednesday, thursday, friday, saturday, sunday,
            blueBadgeNumber,
            blueBadgeExpiryDate,
            maxStayMinutes, 
            noReturnWithinMinutes
        });

        this.put('/' + orgId + "/allowed-vrms/" + vrmId, body, onSuccess, onError, token);
    },

    allowedVrmEnableDisable(onSuccess, onError, allowedVrmId, isEnabled, organisationId, token) {
        this.patch(`/${organisationId}/allowed-vrms/${allowedVrmId}`, JSON.stringify({"isEnabled": isEnabled}), onSuccess, onError, token)
    },

    deleteAllowedVrm(onSuccess, orgId, allowedVrmId, token) {
        this.delete('/' + orgId + '/allowed-vrms/' + allowedVrmId, onSuccess, null, token);
    },

    // Disallow list

    searchDisallowedVrms(onSuccess, onError, searchMode, page, query, vrm, from, to, similarityThreshold, siteId, allowedVrmFilterDateType, sortBy, sortDirection, tagIds, orgId, token, enableAbortController) {
        if (enableAbortController) {
            if (_disallowListAbortController) {
                _disallowListAbortController.abort()
            };

            _disallowListAbortController = new AbortController();
        }

        let body = JSON.stringify({
            query,
            vrm,
            from,
            to,
            searchMode,
            page,
            similarityThreshold,
            siteId,
            allowedVrmFilterDateType,
            sortBy,
            sortDirection,
            tagIds
        });
        this.post(`/${orgId}/disallowed-vrms/search`, body, onSuccess, onError, token, enableAbortController ? _disallowListAbortController.signal : null);
    },

    getDisallowedVrm(onSuccess, onError, disallowedVrmId, orgId, token) {
        this.get(`/${orgId}/disallowed-vrms/${disallowedVrmId}`, onSuccess, onError, token)
    },

    addDisallowedVrm(onSuccess, onError, vrm, vehicleMake, vehicleModel, vehicleColour, driverName, driverMobileNumber, driverEmailAddress, startDate, endDate, siteId, clientId, notes, isEnabled, orgId, token) {

        let body = JSON.stringify({
            vrm,
            vehicleMake,
            vehicleModel,
            vehicleColour,
            driverName,
            driverMobileNumber,
            driverEmailAddress,
            startDate,
            endDate,
            siteId,
            clientId,
            notes,
            isEnabled
        });

        this.put(`/${orgId}/disallowed-vrms/add`, body, onSuccess, onError, token);
    },

    editDisallowedVrm(onSuccess, onError, disallowedVrmId, vrm, vehicleMake, vehicleModel, vehicleColour, driverName, driverMobileNumber, driverEmailAddress, startDate, endDate, siteId, clientId, notes, isEnabled, orgId, token) {

        let body = JSON.stringify({
            vrm,
            vehicleMake,
            vehicleModel,
            vehicleColour,
            driverName,
            driverMobileNumber,
            driverEmailAddress,
            startDate,
            endDate,
            siteId,
            clientId,
            notes,
            isEnabled
        });

        this.put(`/${orgId}/disallowed-vrms/${disallowedVrmId}`, body, onSuccess, onError, token);
    },


    deleteDisallowedVrm(onSuccess, onError, disallowedVrmId, orgId, token) {
        this.delete(`/${orgId}/disallowed-vrms/${disallowedVrmId}`, onSuccess, onError, token);
    },

    deleteMultipleDisallowedVrms(onSuccess, onError, vrms, orgId, token) {
        this.delete(`/${orgId}/disallowed-vrms`, onSuccess, onError, token, JSON.stringify({vrms}));
    },

    disallowedVrmEnableDisable(onSuccess, onError, disallowedVrmId, isEnabled, organisationId, token) {
        this.patch(`/${organisationId}/disallowed-vrms/${disallowedVrmId}`, JSON.stringify({"isEnabled": isEnabled}), onSuccess, onError, token)
    },

    getTags(onSuccess, onError, organisationId, token) {
        this.get('/' + organisationId + '/tags', onSuccess, onError, token);
    },

    getTag(onSuccess, onError, orgId, tagId, token) {
        this.get('/' + orgId + '/tags/' + tagId, onSuccess, onError, token);
    },

    addTag(onSuccess, onError, tagName, tagColour, orgId, token) {

        let body = JSON.stringify({
            "name": tagName,
            "colourCode": tagColour,
        });

        this.post(`/${orgId}/tags`, body, onSuccess, onError, token);
    },

    editTag(onSuccess, onError, tagName, tagColour, tagId, orgId, token) {

        let body = JSON.stringify({
            "name": tagName,
            "colourCode": tagColour,
            "id": tagId,
        });

        this.put('/' + orgId + "/tags/" + tagId, body, onSuccess, onError, token);
    },

    deleteTag(onSuccess, orgId, tagId, token) {
        this.delete('/' + orgId + '/tags/' + tagId, onSuccess, null, token);
    },

    addClientTag(onSuccess, onError, orgId, clientId, tagId, token) {
        this.put('/' + orgId + "/clients/" + clientId + '/tags/' + tagId, null, onSuccess, onError, token);
    },

    deleteClientTag(onSuccess, onError, orgId, clientId, tagId, token) {
        this.delete('/' + orgId + "/clients/" + clientId + '/tags/' + tagId, onSuccess, onError, token);
    },

    addSiteTag(onSuccess, onError, orgId, siteId, tagId, token) {
        this.put('/' + orgId + "/sites/" + siteId + '/tags/' + tagId, null, onSuccess, onError, token);
    },

    deleteSiteTag(onSuccess, onError, orgId, siteId, tagId, token) {
        this.delete('/' + orgId + "/sites/" + siteId + '/tags/' + tagId, onSuccess, onError, token);
    },

    getContraventions(onSuccess, onError, organisationId, token) {
        this.get('/' + organisationId + '/contraventions', onSuccess, onError, token);
    },

    getContravention(onSuccess, onError, organisationId, contraventionId, token) {
        this.get('/' + organisationId + '/contraventions/' + contraventionId, onSuccess, onError, token);
    },

    addContravention(onSuccess, onError, name, dvlaCode, type, status, appealReply, reducedChargeAmount, reducedChargeDays, fullChargeAmount, fullChargeDays, byelawCode, byelawDescription, orgId, token) {

        let body = JSON.stringify({
            "name": name,
            "dvlaCode": dvlaCode,
            "contraventionType": type,
            "isActive": status,
            "appealReply": appealReply,
            reducedChargeAmount,
            reducedChargeDays,
            fullChargeAmount,
            fullChargeDays,
            byelawCode,
            byelawDescription
        });

        this.put('/' + orgId + "/contraventions/add", body, onSuccess, onError, token);
    },

    editContravention(onSuccess, onError, name, dvlaCode, type, status, appealReply, reducedChargeAmount, reducedChargeDays, fullChargeAmount, fullChargeDays, byelawCode, byelawDescription, orgId, contraventionId, token) {

        let body = JSON.stringify({
            "name": name,
            "dvlaCode": dvlaCode,
            "contraventionType": type,
            "isActive": status,
            "appealReply": appealReply,
            reducedChargeAmount,
            reducedChargeDays,
            fullChargeAmount,
            fullChargeDays,
            byelawCode,
            byelawDescription
        });

        this.put('/' + orgId + "/contraventions/" + contraventionId, body, onSuccess, onError, token);
    },

    deleteContravention(onSuccess, orgId, contraventionId, token) {
        this.delete('/' + orgId + '/contraventions/' + contraventionId, onSuccess, null, token);
    },

    getKioskDevices(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/kiosk-devices', onSuccess, onError, token);
    },

    deleteKioskDevice(onSuccess, onError, orgId, deviceId, token) {
        this.delete('/' + orgId + '/kiosk-devices/' + deviceId, onSuccess, onError, token);
    },

    getKioskBySite(onSuccess, onError, orgId, siteId, token) {
        this.get('/' + orgId + '/web-kiosk/' + siteId, onSuccess, onError, token)
    },

    getSiteCameras(onSuccess, onError, orgId, siteId, token) {
        this.get('/' + orgId + '/sites/' + siteId + '/anpr-cameras', onSuccess, onError, token);
    },

    getCameras(outputFormat, onSuccess, onError, orgId, token) {
        if (outputFormat === 0) {
            this.post(`/${orgId}/anpr-cameras/search`, JSON.stringify({outputFormat}) , onSuccess, onError, token);
        } else {
            this.postForBlob(`/${orgId}/anpr-cameras/search`, JSON.stringify({outputFormat}) , onSuccess, onError, token)
        }
    },

    getMacAddresses(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/anpr-cameras/mac-addresses`, onSuccess, onError, token)
    },

    getCameraHeartbeats(onSuccess, onError, cameraId, pageNumber, orgId, token) {
        this.get('/' + orgId + '/anpr-cameras/' + cameraId + '/heartbeats/' + pageNumber, onSuccess, onError, token);
    },

    getCameraTags(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/anpr-cameras/tags`, onSuccess, onError, token);
    },

    getCamera(onSuccess, onError, orgId, cameraId, token) {
        this.get('/' + orgId + '/anpr-cameras/' + cameraId, onSuccess, onError, token);
    },

    addCameraRoi(orgId, cameraId, name, polygon, onSuccess, onError, token) {
        let body = JSON.stringify({
            "name": name,
            "polygon": polygon,
        });
        this.post(`/${orgId}/anpr-cameras/${cameraId}/regions-of-interest`, body, onSuccess, onError, token)
    },

    editCameraRoi(orgId, cameraId, roiId, name, polygon, onSuccess, onError, token) {
        let body = JSON.stringify({
            "name": name,
            "polygon": polygon,
        });
        this.put(`/${orgId}/anpr-cameras/${cameraId}/regions-of-interest/${roiId}`, body, onSuccess, onError, token)
    },

    getCameraRegionsOfInterest(orgId, cameraId, onSuccess, onError, token) {
        this.get(`/${orgId}/anpr-cameras/${cameraId}/regions-of-interest`, onSuccess, onError, token)
    },

    getCameraRoiById(orgId, cameraId, roiId, onSuccess, onError, token) {
        this.get(`/${orgId}/anpr-cameras/${cameraId}/regions-of-interest/${roiId}`, onSuccess, onError, token)
    },

    deleteCameraRegionOfInterest(orgId, cameraId, roiId, onSuccess, onError, token) {
        this.delete(`/${orgId}/anpr-cameras/${cameraId}/regions-of-interest/${roiId}`, onSuccess, onError, token)
    },

    addCamera(onSuccess, onError, name, macAddress, ipAddress, inTag, outTag, isExclusionCamera, exclusionStartTimeBuffer, exclusionEndTime, isBayMonitoringCamera, status, orgId, siteId, token) {

        let body = JSON.stringify({
            "name": name,
            "macAddress": macAddress,
            "ipAddress": ipAddress,
            "inTag": inTag,
            "outTag": outTag,
            "isExclusionCamera": isExclusionCamera,
            exclusionStartTimeBuffer,
            exclusionEndTime,
            isBayMonitoringCamera,
            "isActive": status,
            "siteId": siteId,
        });

        this.put('/' + orgId + "/anpr-cameras/add", body, onSuccess, onError, token);
    },

    editCamera(onSuccess, onError, name, macAddress, ipAddress, inTag, outTag, isExclusionCamera, exclusionStartTimeBuffer, exclusionEndTime, isBayMonitoringCamera, status, orgId, cameraId, siteId, token) {

        let body = JSON.stringify({
            "name": name,
            "macAddress": macAddress,
            "ipAddress": ipAddress,
            "inTag": inTag,
            "outTag": outTag,
            "isExclusionCamera": isExclusionCamera,
            exclusionStartTimeBuffer,
            exclusionEndTime,
            isBayMonitoringCamera,
            "isActive": status,
            "siteId": siteId,
        });

        this.put('/' + orgId + "/anpr-cameras/" + cameraId, body, onSuccess, onError, token);
    },

    deleteCamera(onSuccess, orgId, cameraId, token) {
        this.delete('/' + orgId + '/anpr-cameras/' + cameraId, onSuccess, null, token);
    },

    getOrganisationSettings(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/settings', onSuccess, onError, token);
    },

    editOrganisationSettings(onSuccess, onError, parkonomyApiKey, iasPrivateHash, iasPublicHash, paymentProvider,
                             stripePublishableKey, stripeSecretKey, stripeWebhookSecret, themeColour, customCss, logoId, hostName, kadoeConnectionType, kadoeUsername, kadoePassword, kadoeEnquirerId, kadoeApiKey, ringGoApiPrivateKey, ringGoApiPublicKey, justParkApiKey, tap2ParkApiKey, payByPhoneUsername, payByPhonePassword, parkBunnyApiKey, conviousApiKey, purgeNonPcnCameraDataMonths, disableAutomaticVehicleDetailsLookup,
                             ipcDataExportEnabled, ipcDataExportHostName, ipcDataExportUsername, ipcDataExportPassword, ipcDataExportBucket, ipcDataExportEncryptionKey, ipcDataExportStaticIv, readyForDebtRecoveryDays, ipsApiKey, emailsEnabled, emailSenderName, emailSenderAddress, appealReceivedSubject, appealReceivedContent, transferOfLiabilityReceivedSubject, transferOfLiabilityReceivedContent,
                             cameraStatusWarningThreshold, cameraStatusDangerThreshold, kioskStatusWarningThreshold, kioskStatusDangerThreshold, vehicleAnalyticsEnabled, clientAllowedVrmStartDateRequired, lookingForCarParkApiKey, newParkApiKey, enableTransfer360, ftpUsername, ftpPassword, parksoApiKey, poplaCodePrefixEnglandAndWales, poplaCodePrefixScotland, poplaCodePrefixNorthernIreland, myCarPassApiKey, appealAcceptedResponseSubject, appealAcceptedResponseStatus, appealAcceptedResponseContent, appealDeclinedResponseSubject, appealDeclinedResponseStatus, appealDeclinedResponseContent, appealAcceptedResponseResetDateIssued, appealAcceptedResponseResetCharges, appealAcceptedResponseAdditionalCharge, appealAcceptedResponseAdditionalChargeType, appealAcceptedResponseDebtRecoveryCharge, appealAcceptedResponseDebtRecoveryChargeType, appealDeclinedResponseResetDateIssued, appealDeclinedResponseResetCharges, appealDeclinedResponseAdditionalCharge, appealDeclinedResponseAdditionalChargeType, appealDeclinedResponseDebtRecoveryCharge, appealDeclinedResponseDebtRecoveryChargeType, orgId, token) {

        let body = JSON.stringify({
            parkonomyApiKey,
            iasPublicHash,
            iasPrivateHash,
            paymentProvider,
            stripePublishableKey,
            stripeSecretKey,
            stripeWebhookSecret,
            "managePcnLogoAttachmentId": logoId,
            themeColour,
            "managePcnCustomCss": customCss,
            "managePcnHostName": hostName,
            kadoeConnectionType,
            kadoeUsername,
            kadoePassword,
            kadoeEnquirerId,
            kadoeApiKey,
            ringGoApiPrivateKey,
            ringGoApiPublicKey,
            justParkApiKey,
            tap2ParkApiKey,
            payByPhoneUsername,
            payByPhonePassword,
            parkBunnyApiKey,
            conviousApiKey,
            purgeNonPcnCameraDataMonths,
            disableAutomaticVehicleDetailsLookup,
            ipcDataExportEnabled,
            ipcDataExportHostName,
            ipcDataExportUsername,
            ipcDataExportPassword,
            ipcDataExportBucket,
            ipcDataExportEncryptionKey,
            ipcDataExportStaticIv,
            readyForDebtRecoveryDays,
            ipsApiKey,
            emailsEnabled,
            emailSenderName,
            emailSenderAddress,
            appealReceivedSubject,
            appealReceivedContent,
            transferOfLiabilityReceivedSubject,
            transferOfLiabilityReceivedContent,
            cameraStatusWarningThreshold,
            cameraStatusDangerThreshold,
            kioskStatusWarningThreshold,
            kioskStatusDangerThreshold,
            vehicleAnalyticsEnabled,
            clientAllowedVrmStartDateRequired,
            lookingForCarParkApiKey,
            newParkApiKey,
            enableTransfer360,
            ftpUsername,
            ftpPassword,
            parksoApiKey,
            poplaCodePrefixEnglandAndWales,
            poplaCodePrefixScotland,
            poplaCodePrefixNorthernIreland,
            myCarPassApiKey,
            enableTransfer360,
            appealAcceptedResponseSubject, 
            appealAcceptedResponseStatus, 
            appealAcceptedResponseContent, 
            appealDeclinedResponseSubject, 
            appealDeclinedResponseStatus, 
            appealDeclinedResponseContent,
            appealAcceptedResponseResetDateIssued, 
            appealAcceptedResponseResetCharges, 
            appealAcceptedResponseAdditionalCharge, 
            appealAcceptedResponseAdditionalChargeType, 
            appealAcceptedResponseDebtRecoveryCharge, 
            appealAcceptedResponseDebtRecoveryChargeType, 
            appealDeclinedResponseResetDateIssued, 
            appealDeclinedResponseResetCharges, 
            appealDeclinedResponseAdditionalCharge, 
            appealDeclinedResponseAdditionalChargeType, 
            appealDeclinedResponseDebtRecoveryCharge, 
            appealDeclinedResponseDebtRecoveryChargeType
        });

        this.put('/' + orgId + "/settings", body, onSuccess, onError, token);
    },

    enableVehicleAnalytics(siteIds, organisationId, onSuccess, onError, token) {
        this.patch(`/${organisationId}/sites/enable-vehicle-analytics`, JSON.stringify({siteIds}), onSuccess, onError, token)
    },

    generateKadoePassword(onSuccess, onError, organisationId, token) {
        this.post(`/${organisationId}/settings/kadoe-password`, null, onSuccess, onError, token, null)
    },

    generateKadoeApiKey(onSuccess, onError, organisationId, token) {
        this.post(`/${organisationId}/settings/kadoe-api-key`, null, onSuccess, onError, token, null)
    },

    getGlobalSettings(onSuccess, onError, token) {
        this.get("/global-settings", onSuccess, onError, token);
    },

    generateGlobalKadoePassword(onSuccess, onError, token) {
        this.post("/global-settings/kadoe-password", null, onSuccess, onError, token, null)
    },

    generateGlobalKadoeApiKey(onSuccess, onError, token) {
        this.post("/global-settings/kadoe-api-key", null, onSuccess, onError, token, null)
    },

    generateGlobalKadoeEnhancedPassword(onSuccess, onError, token) {
        this.post("/global-settings/kadoe-enhanced-password", null, onSuccess, onError, token, null)
    },

    generateGlobalKadoeEnhancedApiKey(onSuccess, onError, token) {
        this.post("/global-settings/kadoe-enhanced-api-key", null, onSuccess, onError, token, null)
    },

    editGlobalSettings(kadoeUsername, kadoePassword, kadoeApiKey, kadoeLinkProviderId, kadoeEnhancedUsername, kadoeEnhancedPassword, kadoeEnhancedApiKey, kadoeEnhancedLinkProviderId, onSuccess, onError, token) {
        let body = JSON.stringify({
            kadoeUsername,
            kadoePassword,
            kadoeApiKey,
            kadoeLinkProviderId,
            kadoeEnhancedUsername,
            kadoeEnhancedPassword,
            kadoeEnhancedApiKey,
            kadoeEnhancedLinkProviderId
        });
        this.put("/global-settings", body, onSuccess, onError, token)
    },

    getPayDisplays(onSuccess, onError, orgId, token) {
        this.get('/' + orgId + '/pay-and-display-machines', onSuccess, onError, token);
    },

    getSitePayDisplays(onSuccess, onError, siteId, orgId, token) {
        this.get('/' + orgId + '/sites/' + siteId + '/pay-and-display-machines', onSuccess, onError, token);
    },

    getPayDisplay(onSuccess, onError, payDisplayId, orgId, token) {
        this.get('/' + orgId + '/pay-and-display-machines/' + payDisplayId, onSuccess, onError, token);
    },

    addPayDisplay(onSuccess, onError, name, cityCode, machineId, flowbirdTerminalId, status, siteId, orgId, token) {

        let body = JSON.stringify({
            siteId,
            name,
            cityCode,
            machineId,
            flowbirdTerminalId,
            "isActive": status,
        });

        this.put('/' + orgId + "/pay-and-display-machines/add", body, onSuccess, onError, token);
    },

    editPayDisplay(onSuccess, onError, payDisplayId, name, cityCode, machineId, flowbirdTerminalId, status, siteId, orgId, token) {

        let body = JSON.stringify({
            siteId,
            name,
            cityCode,
            machineId,
            flowbirdTerminalId,
            "isActive": status,
        });

        this.put('/' + orgId + "/pay-and-display-machines/" + payDisplayId, body, onSuccess, onError, token);
    },

    deletePayDisplay(onSuccess, orgId, payDisplayId, token) {
        this.delete('/' + orgId + '/pay-and-display-machines/' + payDisplayId, onSuccess, null, token);
    },

    getAllKiosksBySite(onSuccess, onError, organisationId, siteId, token) {
        this.get(`/${organisationId}/${siteId}/site-kiosks`, onSuccess, onError, token)
    },

    getKioskById(onSuccess, onError, organisationId, siteId, siteKioskId, token) {
        this.get(`/${organisationId}/${siteId}/site-kiosks/${siteKioskId}`, onSuccess, onError, token)
    },

    deleteSiteKiosk(onSuccess, onError, organisationId, siteId, siteKioskId, token) {
        this.delete(`/${organisationId}/${siteId}/site-kiosks/${siteKioskId}`, onSuccess, onError, token)
    },

    addNewKiosk(organisationId, siteId, name, timeSpans, isWebEnabled, isAppEnabled, logoAttachmentId, hideExpiryDate, showBlueBadgeNumber, addEntriesToClient, maxStayMinutes, noReturnWithinMinutes, onSuccess, onError, token) {

        let body = JSON.stringify({
            siteId,
            name,
            timeSpans,
            isWebEnabled,
            isAppEnabled,
            logoAttachmentId,
            hideExpiryDate,
            showBlueBadgeNumber,
            addEntriesToClient,
            maxStayMinutes, 
            noReturnWithinMinutes
        });

        this.post(`/${organisationId}/${siteId}/site-kiosks`, body, onSuccess, onError, token)
    },

    updateKioskConfiguration(organisationId, siteId, name, siteKioskId, isAppEnabled, isWebEnabled, timeSpans, logoAttachmentId, hideExpiryDate, showBlueBadgeNumber, addEntriesToClient, maxStayMinutes, noReturnWithinMinutes, onSuccess, onError, token) {
        let body = JSON.stringify({
            name,
            timeSpans,
            isAppEnabled,
            isWebEnabled,
            logoAttachmentId,
            hideExpiryDate,
            showBlueBadgeNumber,
            addEntriesToClient,
            maxStayMinutes, 
            noReturnWithinMinutes
        });
        this.put(`/${organisationId}/${siteId}/site-kiosks/${siteKioskId}`, body, onSuccess, onError, token)
    },

    regeneateKioskShortCode(organisationId, siteId, siteKioskId, onSuccess, onError, token) {
        this.post(`/${organisationId}/${siteId}/site-kiosks/${siteKioskId}/short-code`, null, onSuccess, onError, token)
    },

    getSiteGroupsBySiteId(organisationId, siteId, onSuccess, onError, token) {
        this.get(`/${organisationId}/sites/${siteId}/groups`, onSuccess, onError, token)
    },

    getAllSiteGroups(organisationId, onSuccess, onError, token) {
        this.get(`/${organisationId}/sites/groups`, onSuccess, onError, token)
    },

    addSiteGroup(organisationId, siteId, name, maximumConcurrentParkingSessions, maximumNumberOfAllowListEntries, notes, onSuccess, onError, token) {
        let body = JSON.stringify({
            name,
            maximumConcurrentParkingSessions,
            maximumNumberOfAllowListEntries,
            notes,
        });
        this.post(`/${organisationId}/sites/${siteId}/groups`, body, onSuccess, onError, token)
    },

    editSiteGroup(organisationId, siteId, siteGroupId, name, maximumConcurrentParkingSessions, maximumNumberOfAllowListEntries, notes, onSuccess, onError, token) {
        let body = JSON.stringify({
            name,
            maximumConcurrentParkingSessions,
            maximumNumberOfAllowListEntries,
            notes,
        });
        this.put(`/${organisationId}/sites/${siteId}/groups/${siteGroupId}`, body, onSuccess, onError, token)
    },

    getSiteGroupDetails(organisationId, siteId, siteGroupId, onSuccess, onError, token) {
        this.get(`/${organisationId}/sites/${siteId}/groups/${siteGroupId}`, onSuccess, onError, token)
    },

    deleteSiteGroup(organisationId, siteId, siteGroupId, onSuccess, onError, token) {
        this.delete(`/${organisationId}/sites/${siteId}/groups/${siteGroupId}`, onSuccess, onError, token)
    },

    getCameraData(onSuccess, onError, search, siteId, fromDate, toDate, pageNumber, outputFormat, cameraMacAddress, tagIds, orgId, token) {
        let body = JSON.stringify({
            "searchQuery": search,
            "siteId": siteId,
            "fromDate": fromDate,
            "toDate": toDate,
            "pageNumber": pageNumber,
            "outputFormat": outputFormat,
            cameraMacAddress,
            tagIds
        });
        if (_cameraDataAbortController) {
            _cameraDataAbortController.abort()
        }
        _cameraDataAbortController = new AbortController();

        if (outputFormat === 0) {
            this.post(`/${orgId}/anpr-camera-decodes/search`, body, onSuccess, onError, token, _cameraDataAbortController.signal)
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/anpr-camera-decodes/search`, body, onSuccess, onError, token)
        }
    },

    editCameraData(onSuccess, onError, organisationId, anprCameraReadId, vrm, token) {

        let body = JSON.stringify({
            "vrm": vrm
        });

        this.put('/' + organisationId + '/anpr-camera-decodes/' + anprCameraReadId, body, onSuccess, onError, token);
    },

    redact(onSuccess, onError, imageWidth, imageHeight, redactions, orgId, decodeId, token) {

        let body = JSON.stringify({
            "imageWidth": imageWidth,
            "imageHeight": imageHeight,
            "redactions": redactions,
        });

        this.post('/' + orgId + "/anpr-camera-decodes/" + decodeId + '/redact', body, onSuccess, onError, token);
    },

    redactAttachment(onSuccess, onError, imageWidth, imageHeight, redactions, orgId, attachmentId, token) {

        let body = JSON.stringify({
            "imageWidth": imageWidth,
            "imageHeight": imageHeight,
            "redactions": redactions,
        });

        this.post('/' + orgId + "/attachments/" + attachmentId + '/redact', body, onSuccess, onError, token);
    },

    voidTicket(onSuccess, onError, breachId, voidReasonId, note, orgId, token) {

        let body = JSON.stringify({
            note,
            voidReasonId
        });

        this.post('/' + orgId + "/breaches/" + breachId + "/void", body, onSuccess, onError, token);
    },

    voidMultipleTickets(onSuccess, onError, breachIds, voidReasonId, note, orgId, token) {

        let body = JSON.stringify({
            "breachStatus": 503,
            note,
            breachIds,
            voidReasonId
        });

        this.post('/' + orgId + "/breaches/" + "set-status", body, onSuccess, onError, token);
    },

    sendMultipleTicketsToDebtRecovery(onSuccess, onError, breachIds, note, orgId, token) {
        let body = JSON.stringify({
            "breachStatus": 402,
            note,
            breachIds
        });

        this.post(`/${orgId}/breaches/set-status`, body, onSuccess, onError, token);
    },


    onHoldTicket(onSuccess, onError, note, breachId, onHold, isOnHoldExpiry, orgId, token) {

        let body = JSON.stringify({
            "note": note,
            "isOnHold": onHold,
            "isOnHoldExpiry": isOnHoldExpiry,
        });

        this.post('/' + orgId + "/breaches/" + breachId + "/hold", body, onSuccess, onError, token);
    },

    setBreachStatus(onSuccess, onError, note, breachId, breachStatus, orgId, token) {

        let body = JSON.stringify({
            "note": note,
            "breachStatus": breachStatus,
        });

        this.post('/' + orgId + "/breaches/" + breachId + "/set-status", body, onSuccess, onError, token);
    },

    setBreachReducedCharge(onSuccess, onError, breachId, reducedChargeDays, reducedChargeAmount, orgId, token) {

        let body = JSON.stringify({
            reducedChargeDays,
            reducedChargeAmount
        });

        this.post(`/${orgId}/breaches/${breachId}/set-reduced-charge`, body, onSuccess, onError, token);
    },

    assignTickets(onSuccess, onError, userId, breachIds, orgId, token) {

        let body = JSON.stringify({
            "userId": userId,
            "breachIds": breachIds,
        });

        this.post('/' + orgId + "/breaches/assign", body, onSuccess, onError, token);
    },

    attachNoteToTicket(onSuccess, onError, note, breachId, orgId, token) {

        let body = JSON.stringify({
            "note": note,
        });

        this.post('/' + orgId + "/breaches/" + breachId + '/note', body, onSuccess, onError, token);
    },

    sendTicketToDvla(onSuccess, onError, orgId, breachId, token) {
        this.post('/' + orgId + "/breaches/" + breachId + "/dvla-request", null, onSuccess, onError, token);
    },

    cancelTicket(onSuccess, onError, reasonId, orgId, breachId, token) {

        let body = JSON.stringify({
            "cancellationReasonId": reasonId,
        });

        this.post('/' + orgId + "/breaches/" + breachId + "/cancel", body, onSuccess, onError, token);
    },

    addInvitation(onSuccess, onError, emailAddress, role, clientIds, siteIds, siteGroupIds, wardenNumber, orgId, token) {

        let body = JSON.stringify({
            "emailAddress": emailAddress,
            "organisationId": orgId,
            "role": role,
            "clientIds": clientIds && clientIds.length ? clientIds : [],
            "siteIds": siteIds,
            "siteGroupIds": siteGroupIds,
            wardenNumber
        });

        this.post('/invitations/add', body, onSuccess, onError, token);
    },

    rotateUserApiKey(onSuccess, onError, userId, token) {
        this.post('/users/' + userId + '/api-key/rotate', null, onSuccess, onError, token);
    },

    addApiUser(onSuccess, onError, firstName, lastName, emailAddress, role, clientIds, siteIds, siteGroupIds, orgId, token) {

        let body = JSON.stringify({
            "firstName": firstName,
            "lastName": lastName,
            "emailAddress": emailAddress,
            "organisationId": orgId,
            "role": role,
            "clientIds": clientIds && clientIds.length ? clientIds : [],
            "siteIds": siteIds,
            "siteGroupIds": siteGroupIds
        });

        this.post('/users', body, onSuccess, onError, token);
    },

    getInvitations(onSuccess, onError, pageNumber, orgId, token) {

        let body = JSON.stringify({
            "organisationId": orgId,
            "pageNumber": pageNumber,
        });

        this.post('/invitations/search', body, onSuccess, onError, token);
    },

    resendInvitation(onSuccess, onError, inviteId, token) {
        this.post('/invitations/' + inviteId + '/resend', null, onSuccess, onError, token);
    },

    revokeInvitation(onSuccess, onError, inviteId, token) {
        this.delete('/invitations/' + inviteId, onSuccess, onError, token);
    },

    getInvitation(onSuccess, onError, inviteId, token) {
        this.get('/invitations/' + inviteId, onSuccess, onError, token);
    },

    acceptInvitation(onSuccess, onError, first, last, emailAddress, userId, inviteId, token) {

        let body = JSON.stringify({
            "userId": userId,
            "emailAddress": emailAddress,
            "firstName": first,
            "lastName": last,
        });

        this.post('/invitations/' + inviteId + '/accept', body, onSuccess, onError, token);
    },

    addCancellationReason(onSuccess, onError, name, description, isActive, orgId, token) {

        let body = JSON.stringify({
            "name": name,
            "description": description,
            "isActive": isActive,
        });

        this.put('/' + orgId + '/cancellation-reasons/add', body, onSuccess, onError, token);
    },

    getCancellationReasons(onSuccess, onError, organisationId, token) {
        this.get('/' + organisationId + '/cancellation-reasons', onSuccess, onError, token);
    },

    getCancellationReason(onSuccess, onError, reasonId, organisationId, token) {
        this.get('/' + organisationId + '/cancellation-reasons/' + reasonId, onSuccess, onError, token);
    },

    editCancellationReason(onSuccess, onError, name, description, isActive, reasonId, orgId, token) {

        let body = JSON.stringify({
            "name": name,
            "description": description,
            "isActive": isActive,
        });

        this.put('/' + orgId + '/cancellation-reasons/' + reasonId, body, onSuccess, onError, token);
    },

    deleteCancellationReason(onSuccess, reasonId, orgId, token) {
        this.delete('/' + orgId + '/cancellation-reasons/' + reasonId, onSuccess, null, token);
    },

    getVoidReasons(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/void-reasons`, onSuccess, onError, token);
    },

    getVoidReason(onSuccess, onError, voidReasonId, organisationId, token) {
        this.get(`/${organisationId}/void-reasons/${voidReasonId}`, onSuccess, onError, token);
    },

    addVoidReason(onSuccess, onError, name, description, isActive, organisationId, token) {
        let body = JSON.stringify({
            "name": name,
            "description": description,
            "isActive": isActive,
        });

        this.post(`/${organisationId}/void-reasons`, body, onSuccess, onError, token);
    },

    editVoidReason(onSuccess, onError, voidReasonId, name, description, isActive, organisationId, token) {
        let body = JSON.stringify({
            "name": name,
            "description": description,
            "isActive": isActive,
        });

        this.post(`/${organisationId}/void-reasons/${voidReasonId}`, body, onSuccess, onError, token);
    },

    deleteVoidReason(onSuccess, onError, voidReasonId, organisationId, token) {
        this.delete(`/${organisationId}/void-reasons/${voidReasonId}`, onSuccess, onError, token)
    },

    getAppealSupplementaryResponses(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/appeal-supplementary-responses`, onSuccess, onError, token);
    },

    getAppealSupplementaryResponse(onSuccess, onError, responseId, organisationId, token) {
        this.get(`/${organisationId}/appeal-supplementary-responses/${responseId}`, onSuccess, onError, token);
    },

    addAppealSupplementaryResponse(onSuccess, onError, name, content, organisationId, token) {
        let body = JSON.stringify({
            name,
            content
        });

        this.post(`/${organisationId}/appeal-supplementary-responses`, body, onSuccess, onError, token);
    },

    editAppealSupplementaryResponse(onSuccess, onError, responseId, name, content, organisationId, token) {
        let body = JSON.stringify({
            name,
            content
        });

        this.put(`/${organisationId}/appeal-supplementary-responses/${responseId}`, body, onSuccess, onError, token);
    },

    deleteAppealSupplementaryResponse(onSuccess, onError, responseId, organisationId, token) {
        this.delete(`/${organisationId}/appeal-supplementary-responses/${responseId}`, onSuccess, onError, token)
    },

    getAllContacts(onSuccess, onError, breachId, organisationId, token) {
        this.get('/' + organisationId + '/breaches/' + breachId + "/contact-details", onSuccess, onError, token);
    },

    getContactDetails(onSuccess, onError, breachId, contactDetailsId, organisationId, token) {
        this.get(`/${organisationId}/breaches/${breachId}/contact-details/${contactDetailsId}`, onSuccess, onError, token)
    },

    editContactDetails(onSuccess, onError, firstName, lastName, title, companyName, emailAddress, contactNumber, contactType, contactSource, addressLine1, addressLine2, addressLine3, townOrCity, postCode, country, isActive, fileId, detailsId, breachId, orgId, token) {

        let body = JSON.stringify({
            "firstName": firstName,
            "lastName": lastName,
            "title": title,
            "companyName": companyName,
            "emailAddress": emailAddress,
            "mobilePhoneNumber": contactNumber,
            "contactType": contactType,
            "contactSource": contactSource,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "townOrCity": townOrCity,
            "postCode": postCode,
            "country": country,
            "isActive": isActive,
            "attachmentId": fileId,
        });

        this.put('/' + orgId + '/breaches/' + breachId + '/contact-details/' + detailsId, body, onSuccess, onError, token);
    },

    addContactDetails(onSuccess, onError, firstName, lastName, title, companyName, emailAddress, contactNumber, contactType, contactSource, addressLine1, addressLine2, addressLine3, townOrCity, postCode, country, isActive, fileId, breachId, orgId, token) {

        let body = JSON.stringify({
            "firstName": firstName,
            "lastName": lastName,
            "title": title,
            "companyName": companyName,
            "emailAddress": emailAddress,
            "mobilePhoneNumber": contactNumber,
            "contactType": contactType,
            "contactSource": contactSource,
            "addressLine1": addressLine1,
            "addressLine2": addressLine2,
            "addressLine3": addressLine3,
            "townOrCity": townOrCity,
            "postCode": postCode,
            "country": country,
            "isActive": isActive,
            "attachmentId": fileId,
        });

        this.post('/' + orgId + '/breaches/' + breachId + '/contact-details', body, onSuccess, onError, token);
    },

    deleteContactDetails(onSuccess, onError, detailsId, breachId, orgId, token) {
        this.delete('/' + orgId + '/breaches/' + breachId + "/contact-details/" + detailsId, onSuccess, onError, token);
    },

    redactContactDetails(onSuccess, onError, detailsId, breachId, orgId, token) {
        this.post('/' + orgId + '/breaches/' + breachId + "/contact-details/" + detailsId + "/redact", null, onSuccess, onError, token);
    },

    vehicleLookup(onSuccess, onError, vrm, orgId, token) {
        this.get('/' + orgId + '/vehicle-lookup/' + vrm, onSuccess, onError, token);
    },

    editBreach(onSuccess, onError, vrm, lookupMake, lookupModel, lookupColour, contraventionId, breachId, siteId, observedFrom, observedTo, orgId, token) {

        let body = JSON.stringify({
            "vrm": vrm,
            "vehicleMake": lookupMake,
            "vehicleModel": lookupModel,
            "vehicleColour": lookupColour,
            "contraventionId": contraventionId,
            siteId,
            observedFrom,
            observedTo

        });

        this.patch('/' + orgId + '/breaches/' + breachId, body, onSuccess, onError, token);
    },

    getTransferOfLiability(onSuccess, onError, breachId, transferOfLiabilityId, organisationId, token) {
        this.get(`/${organisationId}/breaches/${breachId}/transfer-of-liability/${transferOfLiabilityId}`, onSuccess, onError, token)
    },

    getTransfersLiability(onSuccess, onError, breachId, organisationId, token) {
        this.get('/' + organisationId + '/breaches/' + breachId + "/transfer-of-liability", onSuccess, onError, token);
    },

    acceptTransferLiability(onSuccess, onError, breachId, transferOfLiabilityId, response, orgId, token) {
        this.post('/' + orgId + '/breaches/' + breachId + '/transfer-of-liability/' + transferOfLiabilityId + '/accept', JSON.stringify({"response": response}), onSuccess, onError, token);
    },

    declineTransferLiability(onSuccess, onError, breachId, transferOfLiabilityId, response, orgId, token) {
        this.post('/' + orgId + '/breaches/' + breachId + '/transfer-of-liability/' + transferOfLiabilityId + '/decline', JSON.stringify({"response": response}), onSuccess, onError, token);
    },

    addTransferLiability(onSuccess, onError, notifier, liabilityParty, timestamp, breachId, orgId, token) {

        let body = JSON.stringify({
            "notifier": notifier,
            "liabilityParty": liabilityParty,
            timestamp
        });

        this.put('/' + orgId + '/breaches/' + breachId + '/transfer-of-liability/add', body, onSuccess, onError, token);
    },

    getAppeals(onSuccess, onError, breachId, organisationId, token) {
        this.get('/' + organisationId + '/breaches/' + breachId + "/appeals", onSuccess, onError, token);
    },

    getAppeal(onSuccess, onError, breachId, appealId, organisationId, token) {
        this.get('/' + organisationId + '/breaches/' + breachId + "/appeals/" + appealId, onSuccess, onError, token);
    },

    deleteAppeal(onSuccess, onError, breachId, appealId, organisationId, token) {
        this.delete('/' + organisationId + '/breaches/' + breachId + "/appeals/" + appealId, onSuccess, onError, token);
    },

    acceptAppeal(onSuccess, onError, breachId, appealId, appealResponse, attachmentIds, responseMode, letterTemplateId, letterTemplateItems, emailSubject, emailContent, emailStatus, orgId, token) {
        this.post('/' + orgId + '/breaches/' + breachId + '/appeals/' + appealId + '/accept', JSON.stringify({ appealResponse, attachmentIds, responseMode, letterTemplateId, letterTemplateItems, emailSubject, emailContent, emailStatus }), onSuccess, onError, token);
    },

    declineAppeal(onSuccess, onError, breachId, appealId, appealResponse, attachmentIds, responseMode, letterTemplateId, letterTemplateItems, emailSubject, emailContent, emailStatus, appealSupplementaryResponseId, orgId, token) {
        this.post('/' + orgId + '/breaches/' + breachId + '/appeals/' + appealId + '/decline', JSON.stringify({ appealResponse, attachmentIds, responseMode, letterTemplateId, letterTemplateItems, emailSubject, emailContent, emailStatus, appealSupplementaryResponseId }), onSuccess, onError, token);
    },

    getAppealResponseOptions(onSuccess, onError, breachId, appealId, responseType, organisationId, token) {
        this.get(`/${organisationId}/breaches/${breachId}/appeals/${appealId}/${responseType}/options`, onSuccess, onError, token)
    },

    refreshAppealAcceptEmailPreview(onSuccess, onError, breachId, appealId, subject, status, content, organisationId, token) {
        const body = JSON.stringify({subject, status, content})
        this.post(`/${organisationId}/breaches/${breachId}/appeals/${appealId}/accept/email/preview`, body, onSuccess, onError, token)
    },

    refreshAppealDeclineEmailPreview(onSuccess, onError, breachId, appealId, subject, status, content, organisationId, token) {
        const body = JSON.stringify({subject, status, content})
        this.post(`/${organisationId}/breaches/${breachId}/appeals/${appealId}/decline/email/preview`, body, onSuccess, onError, token)
    },

    addAppeal(onSuccess, onError, appealantDetails, appealReason, attachmentIds, timestamp, breachId, orgId, token) {

        let body = JSON.stringify({
            "appealantDetails": appealantDetails,
            "appealReason": appealReason,
            "attachmentIds": attachmentIds,
            timestamp
        });

        this.put('/' + orgId + '/breaches/' + breachId + '/appeals/add', body, onSuccess, onError, token);
    },

    addAppealAttachment(onSuccess, onError, breachId, appealId, attachmentId, organisationId, token) {
        this.put(`/${organisationId}/breaches/${breachId}/appeals/${appealId}/attachments/${attachmentId}`, null, onSuccess, onError, token)
    },

    deleteAppealAttachment(onSuccess, onError, breachId, appealId, attachmentId, organisationId, token) {
        this.delete(`/${organisationId}/breaches/${breachId}/appeals/${appealId}/attachments/${attachmentId}`, onSuccess, onError, token)
    },

    getLetterTemplates(onSuccess, onError, organisationId, token) {
        this.get('/' + organisationId + '/letter-templates', onSuccess, onError, token);
    },

    getLetterTemplate(onSuccess, onError, templateId, organisationId, token) {
        this.get('/' + organisationId + '/letter-templates/' + templateId, onSuccess, onError, token);
    },

    addLetterTemplate(onSuccess, onError,
                      additionalChargeType, additionalCharge, debtRecoveryCharge, debtRecoveryChargeType,
                      completeStatus, resetCharges, resetDateIssued, processOnMondays, processOnTuesdays,
                      processOnWednesdays, processOnThursdays, processOnFridays, processOnSaturdays,
                      processOnSundays, processOnPublicHoildays, processingTime, contraventions, allowManualSend, attachmentsPerPage, attachmentId, name, items, isActive, orgId, token) {

        let body = JSON.stringify({
            "attachmentId": attachmentId,
            "name": name,
            "isActive": isActive,
            "items": items,
            "additionalCharge": additionalCharge,
            "additionalChargeType": additionalChargeType,
            "debtRecoveryCharge": debtRecoveryCharge,
            "debtRecoverChargeType": debtRecoveryChargeType,
            "completeStatus": completeStatus,
            "resetCharges": resetCharges,
            "resetDateIssued": resetDateIssued,
            "processOnPublicHoildays": processOnPublicHoildays,
            "processOnMondays": processOnMondays,
            "processOnTuesdays": processOnTuesdays,
            "processOnWednesdays": processOnWednesdays,
            "processOnThursdays": processOnThursdays,
            "processOnFridays": processOnFridays,
            "processOnSaturdays": processOnSaturdays,
            "processOnSundays": processOnSundays,
            "processingTime": processingTime,
            "contraventions": contraventions,
            "allowManualSend": allowManualSend,
            "attachmentsPerPage": attachmentsPerPage,
        });

        this.put('/' + orgId + '/letter-templates/add', body, onSuccess, onError, token);
    },

    editLetterTemplate(onSuccess, onError,
                       additionalChargeType, additionalCharge, debtRecoveryCharge, debtRecoveryChargeType,
                       completeStatus, resetCharges, resetDateIssued, processOnMondays, processOnTuesdays,
                       processOnWednesdays, processOnThursdays, processOnFridays, processOnSaturdays,
                       processOnSundays, processOnPublicHoildays, processingTime, contraventions, allowManualSend, attachmentsPerPage, templateId, attachmentId, name, items, isActive, orgId, token) {

        let body = JSON.stringify({
            "attachmentId": attachmentId,
            "name": name,
            "isActive": isActive,
            "items": items,
            "additionalCharge": additionalCharge,
            "additionalChargeType": additionalChargeType,
            "debtRecoveryCharge": debtRecoveryCharge,
            "debtRecoverChargeType": debtRecoveryChargeType,
            "completeStatus": completeStatus,
            "resetCharges": resetCharges,
            "resetDateIssued": resetDateIssued,
            "processOnPublicHoildays": processOnPublicHoildays,
            "processOnMondays": processOnMondays,
            "processOnTuesdays": processOnTuesdays,
            "processOnWednesdays": processOnWednesdays,
            "processOnThursdays": processOnThursdays,
            "processOnFridays": processOnFridays,
            "processOnSaturdays": processOnSaturdays,
            "processOnSundays": processOnSundays,
            "processingTime": processingTime,
            "contraventions": contraventions,
            "allowManualSend": allowManualSend,
            "attachmentsPerPage": attachmentsPerPage
        });

        this.put('/' + orgId + '/letter-templates/' + templateId, body, onSuccess, onError, token);
    },

    copyLetterTemplate(organisationId, letterTemplateId, name, onSuccess, onError, token) {
        this.post(`/${organisationId}/letter-templates/${letterTemplateId}/copy`, JSON.stringify({name}), onSuccess, onError, token)
    },

    newLetter(organisationId, letterTemplateId, breachId, contactId, letterMode, letterTemplateItems, attachmentIds, onSuccess, onError, token) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append('Authorization', 'Bearer ' + token);

        let body = JSON.stringify({
            "letterTemplateId": letterTemplateId,
            "breachId": breachId,
            "contactId": contactId,
            "letterMode": letterMode,
            "letterTemplateItems": letterTemplateItems,
            attachmentIds
        })
        if (_previewAbortController) {
            _previewAbortController.abort()
        }
        _previewAbortController = new AbortController();

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: body,
            responseType: 'blob',
            redirect: 'follow',
            signal: _previewAbortController.signal
        };

        fetch(baseUrl + '/' + organisationId + '/letters', requestOptions)
            .then(this.handleErrors)
            .then(function (response) {
                return response.blob();
            }).then(function (blob) {
            onSuccess(blob);
        }).catch((error) => {
            onError(error)
        });

    },

    getSelectedTemplateItems(organisationId, letterTemplateId, breachId, contactId, onSuccess, onError, token) {
        let body = JSON.stringify({
            "breachId": breachId,
            "contactId": contactId
        })
        this.post(`/${organisationId}/letter-templates/${letterTemplateId}/preview`, body, onSuccess, onError, token)
    },

    previewLetterTemplate(onSuccess, onError, attachmentId, items, showOutOfBounds, showGridLines, breachId, orgId, token) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append('Authorization', 'Bearer ' + token);

        var raw = JSON.stringify({
            "attachmentId": attachmentId,
            "items": items,
            "showOutOfBoundsAreas": showOutOfBounds,
            "showGridLines": showGridLines,
            "breachId": breachId,
        });

        if (_previewAbortController) {
            _previewAbortController.abort()
        }
        _previewAbortController = new AbortController();

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            responseType: 'blob',
            redirect: 'follow',
            signal: _previewAbortController.signal
        };

        fetch(baseUrl + '/' + orgId + '/letter-templates/preview', requestOptions)
            .then(this.handleErrors)
            .then(function (response) {
                return response.blob();
            }).then(function (blob) {
            onSuccess(blob);
        }).catch((error) => {
            onError(error)
        });
    },

    deleteLetterTemplate(onSuccess, onError, templateId, orgId, token) {
        this.delete('/' + orgId + '/letter-templates/' + templateId, onSuccess, onError, token);
    },

    getTemplatePlaceholders(onSuccess, onError, organisationId, token) {
        this.get('/' + organisationId + '/letter-templates/placeholders', onSuccess, onError, token);
    },

    getTemplateCondition(onSuccess, onError, conditionId, templateId, organisationId, token) {
        this.get('/' + organisationId + '/letter-templates/' + templateId + '/conditions/' + conditionId, onSuccess, onError, token);
    },

    editTemplateCondition(onSuccess, onError, conditionId, templateId, conditionType, argument, orgId, token) {

        let body = JSON.stringify({
            "letterTemplateConditionType": conditionType,
            "argument": argument
        });

        this.put('/' + orgId + '/letter-templates/' + templateId + '/conditions/' + conditionId, body, onSuccess, onError, token);
    },

    addTemplateCondition(onSuccess, onError, templateId, conditionType, argument, orgId, token) {

        let body = JSON.stringify({
            "letterTemplateConditionType": conditionType,
            "argument": argument
        });

        this.put('/' + orgId + '/letter-templates/' + templateId + '/conditions/add', body, onSuccess, onError, token);
    },

    deleteTemplateCondition(onSuccess, onError, conditionId, templateId, orgId, token) {
        this.delete('/' + orgId + '/letter-templates/' + templateId + '/conditions/' + conditionId, onSuccess, onError, token);
    },

    searchRingGo(onSuccess, onError, vrm, similarityThreshold, fromDate, toDate, siteId, orgId, token) {
        let body = JSON.stringify({
            "vrm": vrm,
            "similarityThreshold": similarityThreshold,
            "fromDate": fromDate,
            "toDate": toDate,
            siteId
        });
        this.post('/' + orgId + '/ringgo/search', body, onSuccess, onError, token);
    },

    searchParkonomy(onSuccess, onError, vrm, similarityThreshold, fromDate, toDate, siteId, orgId, token) {
        let body = JSON.stringify({
            "vrm": vrm,
            "similarityThreshold": similarityThreshold,
            "fromDate": fromDate,
            "toDate": toDate,
            siteId
        });
        this.post('/' + orgId + '/parkonomy/search', body, onSuccess, onError, token);
    },

    searchParkfolio(onSuccess, onError, vrm, similarityThreshold, fromDate, toDate, siteId, orgId, token) {
        let body = JSON.stringify({
            "vrm": vrm,
            "similarityThreshold": similarityThreshold,
            "fromDate": fromDate,
            "toDate": toDate,
            siteId
        });
        this.post('/' + orgId + '/parkfolio/search', body, onSuccess, onError, token);
    },

    searchFlowbird(onSuccess, onError, vrm, similarityThreshold, fromDate, toDate, siteId, orgId, token) {
        let body = JSON.stringify({
            "vrm": vrm,
            "similarityThreshold": similarityThreshold,
            "fromDate": fromDate,
            "toDate": toDate,
            siteId
        });
        this.post('/' + orgId + '/flowbird/search', body, onSuccess, onError, token);
    },

    searchAllowedVrms(onSuccess, onError, searchMode, page, query, vrm, from, to, similarityThreshold, siteId, allowedVrmFilterDateType, sortBy, sortDirection, createdByUserId, createdBySource, tagIds, globalOnly, clientId, orgId, token, enableAbortController) {

        if (enableAbortController) {
            if (_allowListAbortController) {
                _allowListAbortController.abort()
            };

            _allowListAbortController = new AbortController();
        }

        let body = JSON.stringify({
            query,
            vrm,
            from,
            to,
            searchMode,
            page,
            similarityThreshold,
            siteId,
            allowedVrmFilterDateType,
            sortBy,
            sortDirection,
            createdByUserId,
            createdBySource,
            tagIds,
            globalOnly,
            clientId
        });
        this.post(`/${orgId}/allowed-vrms/search`, body, onSuccess, onError, token, enableAbortController ? _allowListAbortController.signal : null);
    },

    /* REPORTS */

    getExportBreachReports(onSuccess, onError, breachStatus, date, outputFormat, tagIds, orgId, token) {
        if (_exportBreachesReportAbortController) {
            _exportBreachesReportAbortController.abort()
        }
        _exportBreachesReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/breaches`, JSON.stringify({ breachStatus, date, outputFormat, tagIds }), onSuccess, onError, token, _exportBreachesReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/breaches`, JSON.stringify({ breachStatus, date, outputFormat, tagIds }), onSuccess, onError, token);
        }
    },

    getBreachStatusChangeReport(onSuccess, onError, from, to, fromStatus, toStatus, siteId, clientId, outputFormat, orgId, token, signal) {
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/breach-status-change`, JSON.stringify({ from, to, fromStatus, toStatus, siteId, clientId, outputFormat }), onSuccess, onError, token, signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/breach-status-change`, JSON.stringify({ from, to, fromStatus, toStatus, siteId, clientId, outputFormat }), onSuccess, onError, token, signal);
        }
    },

    getPcnsIssuedReport(onSuccess, onError, from, to, outputFormat, groupBy, tagIds, orgId, token) {
        if (_pcnsIssuedReportAbortController) {
            _pcnsIssuedReportAbortController.abort()
        }
        _pcnsIssuedReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/pcns-issued`, JSON.stringify({ outputFormat, from, to, groupBy, tagIds }), onSuccess, onError, token, _pcnsIssuedReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/pcns-issued`, JSON.stringify({ outputFormat, from, to, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getPcnsPaidReports(onSuccess, onError, from, to, outputFormat, siteId, clientId, groupBy, tagIds, orgId, token) {
        if (_pcnsPaidReportAbortController) {
            _pcnsPaidReportAbortController.abort()
        }
        _pcnsPaidReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/pcns-paid`, JSON.stringify({ outputFormat, from, to, siteId, clientId, groupBy, tagIds }), onSuccess, onError, token, _pcnsPaidReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/pcns-paid`, JSON.stringify({ outputFormat, from, to, siteId, clientId, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getDebtRecoveryReport(onSuccess, onError, from, to, outputFormat, siteId, clientId, groupBy, tagIds, orgId, token) {
        if (_debtRecoveryReportAbortController) {
            _debtRecoveryReportAbortController.abort()
        }
        _debtRecoveryReportAbortController = new AbortController();
        const body = JSON.stringify({ from, to, siteId, clientId, outputFormat, groupBy, tagIds })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/debt-recovery`, body, onSuccess, onError, token, _debtRecoveryReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/debt-recovery`, body, onSuccess, onError, token);
        }
    },

    getAverageLengthOfStayReport(onSuccess, onError, from, to, outputFormat, vehicleType, dateRangeType, siteId, orgId, token) {
        if (_averageStayAbortController) {
            _averageStayAbortController.abort()
        }
        _averageStayAbortController = new AbortController();
        const body = JSON.stringify({ from, to, outputFormat, vehicleType, dateRangeType })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/${siteId}/average-stay`, body, onSuccess, onError, token, _averageStayAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/${siteId}/average-stay`, body, onSuccess, onError, token);
        }

    },

    getDailyTotalsReport(onSuccess, onError, from, to, outputFormat, vehicleType, dateRangeType, siteId, orgId, token) {
        if (_dailyTotalsAbortController) {
            _dailyTotalsAbortController.abort()
        }
        _dailyTotalsAbortController = new AbortController();
        const body = JSON.stringify({ from, to, outputFormat, vehicleType, dateRangeType })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/${siteId}/daily-totals`, body, onSuccess, onError, token, _dailyTotalsAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/${siteId}/daily-totals`, body, onSuccess, onError, token);
        }

    },

    getParkingDurationsReport(onSuccess, onError, from, to, outputFormat, vehicleType, dateRangeType, siteId, orgId, token) {
        if (_parkingDurationsAbortController) {
            _parkingDurationsAbortController.abort()
        }
        _parkingDurationsAbortController = new AbortController();
        const body = JSON.stringify({ from, to, outputFormat, vehicleType, dateRangeType })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/${siteId}/parking-durations`, body, onSuccess, onError, token, _parkingDurationsAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/${siteId}/parking-durations`, body, onSuccess, onError, token);
        }

    },

    getContraventionsReport(onSuccess, onError, from, to, outputFormat, dateRangeType, siteId, orgId, token) {
        if (_contraventionsAbortController) {
            _contraventionsAbortController.abort()
        }
        _contraventionsAbortController = new AbortController();
        const body = JSON.stringify({ from, to, outputFormat, dateRangeType })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/${siteId}/contraventions`, body, onSuccess, onError, token, _contraventionsAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/${siteId}/contraventions`, body, onSuccess, onError, token);
        }

    },

    getBreachesReport(onSuccess, onError, from, to, outputFormat, dateRangeType, breachStatus, siteId, orgId, token) {
        if (_breachesReportAbortController) {
            _breachesReportAbortController.abort()
        }
        _breachesReportAbortController = new AbortController();
        const body = JSON.stringify({ from, to, outputFormat, dateRangeType, breachStatus })
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/${siteId}/breaches`, body, onSuccess, onError, token, _breachesReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/${siteId}/breaches`, body, onSuccess, onError, token);
        }

    },

    getAppealsReports(onSuccess, onError, from, to, outputFormat, userId, groupBy, tagIds, token, orgId) {
        if (_appealsReportAbortController) {
            _appealsReportAbortController.abort()
        }
        _appealsReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/appeals`, JSON.stringify({ from, to, outputFormat, userId, groupBy, tagIds }), onSuccess, onError, token, _appealsReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/appeals`, JSON.stringify({ from, to, outputFormat, userId, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getCancellationsReport(onSuccess, onError, from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds, token, orgId) {
        if (_cancellationsReportAbortController) {
            _cancellationsReportAbortController.abort()
        }
        _cancellationsReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/cancellations`, JSON.stringify({ from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds }), onSuccess, onError, token, _cancellationsReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/cancellations`, JSON.stringify({ from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getVoidsReport(onSuccess, onError, from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds, token, orgId) {
        if (_voidsReportAbortController) {
            _voidsReportAbortController.abort()
        }
        _voidsReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/voids`, JSON.stringify({ from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds }), onSuccess, onError, token, _voidsReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/voids`, JSON.stringify({ from, to, siteId, clientId, userId, outputFormat, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getTransferOfLiabilitiesReport(onSuccess, onError, from, to, outputFormat, userId, groupBy, tagIds, token, orgId) {
        if (_tolReportAbortController) {
            _tolReportAbortController.abort()
        }
        _tolReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/transfer-of-liabilities`, JSON.stringify({ from, to, outputFormat, userId, groupBy, tagIds }), onSuccess, onError, token, _tolReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/transfer-of-liabilities`, JSON.stringify({ from, to, outputFormat, userId, groupBy, tagIds }), onSuccess, onError, token);
        }
    },

    getDataStorageReport(onSuccess, onError, from, to, outputFormat, token, orgId) {
        if (_dataStorageReportAbortController) {
            _dataStorageReportAbortController.abort()
        }
        _dataStorageReportAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${orgId}/reports/data-storage`, JSON.stringify({ from, to, outputFormat }), onSuccess, onError, token, _dataStorageReportAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/reports/data-storage`, JSON.stringify({ from, to, outputFormat }), onSuccess, onError, token);
        }
    },

    createScheduledExport(onSuccess, onError, name, reportType, frequency, monday, tuesday, wednesday, thursday, friday, saturday, sunday, sendTime, dayOfMonth, recipients, parameters, isActive, organisationId, token) {
        const body = JSON.stringify({
            name, reportType, frequency, monday, tuesday, wednesday, thursday, friday, saturday, sunday, sendTime, dayOfMonth, recipients, parameters, isActive
        })
        this.post(`/${organisationId}/scheduled-reports`, body, onSuccess, onError, token)
    },

    updateScheduledExport(onSuccess, onError, scheduledExportId, name, reportType, frequency, monday, tuesday, wednesday, thursday, friday, saturday, sunday, sendTime, dayOfMonth, recipients, parameters, isActive, organisationId, token) {
        const body = JSON.stringify({
            name, reportType, frequency, monday, tuesday, wednesday, thursday, friday, saturday, sunday, sendTime, dayOfMonth, recipients, parameters, isActive
        })
        this.put(`/${organisationId}/scheduled-reports/${scheduledExportId}`, body, onSuccess, onError, token)
    },

    getScheduledExport(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/scheduled-reports`, onSuccess, onError, token)
    },

    getScheduledExportById(onSuccess, onError, scheduledReportId, organisationId, token) {
        this.get(`/${organisationId}/scheduled-reports/${scheduledReportId}`, onSuccess, onError, token)
    },

    deleteScheduledExport(onSuccess, onError, scheduledReportId, organisationId, token) {
        this.delete(`/${organisationId}/scheduled-reports/${scheduledReportId}`, onSuccess, onError, token)
    },

    exportSitesCsv(clientId, tagIds, organisationId, onSuccess, onError, token) {
        this.postForBlob(`/${organisationId}/reports/sites`, JSON.stringify({ clientId, tagIds }), onSuccess, onError, token)
    },

    exportAllowListCsv(organisationId, query, from, to, siteId, allowedVrmFilterDateType, sortBy, sortDirection, createdByUserId, createdBySource, tagIds, globalOnly, clientId, onSuccess, onError, token) {
        this.postForBlob(`/${organisationId}/reports/allow-list`, JSON.stringify({ query, from, to, siteId, sortBy, sortDirection, allowedVrmFilterDateType, createdByUserId, createdBySource, tagIds, globalOnly, clientId }), onSuccess, onError, token)
    },

    importAllowList(organisationId, formData, onSuccess, onError, token) {
        this.postForFileUpload(`/${organisationId}/import-data/allowed-vrms`, formData, onSuccess, onError, token, null)
    },

    getKadoeRequests(onSuccess, onError, query, from, to, page, orgId, token) {
        if (_kadoeDataAbortController) {
            _kadoeDataAbortController.abort()
        }
        _kadoeDataAbortController = new AbortController();
        this.post(`/${orgId}/kadoe-requests/search`, JSON.stringify({ query, from, to, page }), onSuccess, onError, token, _kadoeDataAbortController.signal);
    },

    getLettersRawData(onSuccess, onError, query, from, to, page, letterTemplateId, status, tagIds, orgId, token) {
        if (_lettersDataAbortController) {
            _lettersDataAbortController.abort()
        }
        _lettersDataAbortController = new AbortController();

        this.post(`/${orgId}/letters/search`, JSON.stringify({ query, from, to, page, letterTemplateId, status, tagIds }), onSuccess, onError, token, _lettersDataAbortController.signal);
    },

    getEmailsRawData(onSuccess, onError, query, from, to, status, pageNumber, orgId, token) {
        if (_emailsDataAbortController) {
            _emailsDataAbortController.abort()
        }
        _emailsDataAbortController = new AbortController();

        this.post(`/${orgId}/emails/search`, JSON.stringify({ query, from, to, pageNumber, pageSize: 100, status }), onSuccess, onError, token, _emailsDataAbortController.signal);
    },

    getPaymentsData(onSuccess, onError, query, siteId, start, end, page, similarityThreshold, outputFormat, dateSearchMode, tagIds, orgId, token) {

        if (_paymentsDataAbortController) {
            _paymentsDataAbortController.abort()
        }
        _paymentsDataAbortController = new AbortController();
        
        let body = JSON.stringify({ query, siteId, start, end, page, similarityThreshold, outputFormat, dateSearchMode, tagIds });
        if (outputFormat === 0) {
            this.post(`/${orgId}/payments`, body, onSuccess, onError, token, _paymentsDataAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/payments`, body, onSuccess, onError, token);
        }
    },

    getPcnPaymentsData(onSuccess, onError, query, siteId, clientId, dateSearchMode, start, end, includeDeleted, page, similarityThreshold, outputFormat, breachPaymentDateSearchMode, tagIds, orgId, token) {
        let body = JSON.stringify({ query, siteId, includeDeleted, clientId, start, end, page, similarityThreshold, outputFormat, dateSearchMode, breachPaymentDateSearchMode, tagIds });
        if (outputFormat === 0) {
            if (_pcnPaymentsDataAbortController) {
            _pcnPaymentsDataAbortController.abort()
        }
        _pcnPaymentsDataAbortController = new AbortController();
            this.post(`/${orgId}/breach-payments/search`, body, onSuccess, onError, token, _pcnPaymentsDataAbortController.signal);
        } else if (outputFormat === 1) {
            this.postForBlob(`/${orgId}/breach-payments/search`, body, onSuccess, onError, token);
        }
    },

    getNotifications(onSuccess, onError, token) {
        this.get("/notifications", onSuccess, onError, token)
    },

    addNotification(message, type, organisationIds, expiryDate, onSuccess, onError, token) {
        this.post("/notifications", JSON.stringify({ message, type, organisationIds, expiryDate }), onSuccess, onError, token)
    },

    editNotification(notificationId, message, type, organisationIds, expiryDate, onSuccess, onError, token) {
        this.put(`/notifications/${notificationId}`, JSON.stringify({ message, type, organisationIds, expiryDate }), onSuccess, onError, token)
    },

    deleteNotification(notificationId, onSuccess, onError, token) {
        this.delete(`/notifications/${notificationId}`, onSuccess, onError, token)
    },

    getNotificationsByOrganisation(organisationId, onSuccess, onError, token) {
        this.get(`/${organisationId}/notifications`, onSuccess, onError, token)
    },

    getVehicleAnalyticsData(onSuccess, onError, from, to, siteId, clientId, outputFormat, tagIds, organisationId, token) {
        let body = JSON.stringify({ siteId, clientId, from, to, outputFormat, tagIds });
        if (_vehicleAnalyticsAbortController) {
            _vehicleAnalyticsAbortController.abort()
        }
        _vehicleAnalyticsAbortController = new AbortController();
        if (outputFormat === 0) {
            this.post(`/${organisationId}/vehicle-analytics`, body, onSuccess, onError, token, _vehicleAnalyticsAbortController.signal)
        } else {
            this.postForBlob(`/${organisationId}/vehicle-analytics`, body, onSuccess, onError, token)
        }
        
    },

    getRegions(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/regions`, onSuccess, onError, token)
    },

    addRegion(onSuccess, onError, name, organisationId, token) {
        this.post(`/${organisationId}/regions`, JSON.stringify({name}), onSuccess, onError, token)
    },

    getRegion(onSuccess, onError, regionId, organisationId, token) {
        this.get(`/${organisationId}/regions/${regionId}`, onSuccess, onError, token)
    },

    deleteRegion(onSuccess, onError, regionId, organisationId, token) {
        this.delete(`/${organisationId}/regions/${regionId}`, onSuccess, onError, token)
    },

    editRegion(onSuccess, onError, regionId, name, organisationId, token) {
        this.put(`/${organisationId}/regions/${regionId}`, JSON.stringify({name}), onSuccess, onError, token)
    },

    getDebtCollectionProviders(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/debt-collection-providers`, onSuccess, onError, token)
    },

    getDebtCollectionProvider(onSuccess, onError, debtcollectionproviderId, organisationId, token) {
        this.get(`/${organisationId}/debt-collection-providers/${debtcollectionproviderId}`, onSuccess, onError, token)
    },

    addDebtCollectionProvider(onSuccess, onError, name, debtCollectionType, isDefault, debtViewTenant, debtViewUsername, debtViewPassword, debtViewSubscriptionKey, debtViewClientKey, debtViewApiKey, dcblUsername, dcblPassword, dcblClientPointer, dcblPlacement, organisationId, token) {

        const body = JSON.stringify(
            {
                name, 
                debtCollectionType, 
                isDefault, 
                debtViewTenant, 
                debtViewUsername, 
                debtViewPassword, 
                debtViewSubscriptionKey, 
                debtViewClientKey, 
                debtViewApiKey, 
                dcblUsername, 
                dcblPassword, 
                dcblClientPointer, 
                dcblPlacement 
            })

        this.post(`/${organisationId}/debt-collection-providers`, body, onSuccess, onError, token)
    },

    editDebtCollectionProvider(onSuccess, onError, debtcollectionproviderId, name, debtCollectionType, isDefault, debtViewTenant, debtViewUsername, debtViewPassword, debtViewSubscriptionKey, debtViewClientKey, debtViewApiKey, dcblUsername, dcblPassword, dcblClientPointer, dcblPlacement, organisationId, token) {

        const body = JSON.stringify(
            {
                name, 
                debtCollectionType, 
                isDefault, 
                debtViewTenant, 
                debtViewUsername, 
                debtViewPassword, 
                debtViewSubscriptionKey, 
                debtViewClientKey, 
                debtViewApiKey, 
                dcblUsername, 
                dcblPassword, 
                dcblClientPointer, 
                dcblPlacement 
            })

        this.put(`/${organisationId}/debt-collection-providers/${debtcollectionproviderId}`, body, onSuccess, onError, token)
    },

    toggleDebtCollectionDefault(onSuccess, onError, debtcollectionproviderId, isDefault, organisationId, token) {
        this.patch(`/${organisationId}/debt-collection-providers/${debtcollectionproviderId}`, JSON.stringify({isDefault}), onSuccess, onError, token)
    },

    deleteDebtCollectionProvider(onSuccess, onError, debtcollectionproviderId, organisationId, token) {
        this.delete(`/${organisationId}/debt-collection-providers/${debtcollectionproviderId}`, onSuccess, onError, token)
    },

    getSuspensions(onSuccess, onError, query, pageNumber, pageSize, siteIds, from, to, tagIds, organisationId, token) {
        const body = JSON.stringify({query, pageNumber, pageSize, clientId: null, siteIds, from, to, tagIds})
        if (_suspensionsAbortController) {
            _suspensionsAbortController.abort()
        }
        _suspensionsAbortController = new AbortController();

        this.post(`/${organisationId}/suspensions/search`, body, onSuccess, onError, token, _suspensionsAbortController.signal)
    },

    getSuspension(onSuccess, onError, suspensionId, organisationId, token) {
        this.get(`/${organisationId}/suspensions/${suspensionId}`, onSuccess, onError, token)
    },

    addSuspension(onSuccess, onError, name, startDate, endDate, monday, tuesday, wednesday, thursday, friday, saturday, sunday, enabledFromTime, enabledToTime, notes, isEnabled, organisationId, token) {
        const body = JSON.stringify({
            name,
            startDate,
            endDate,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            enabledFromTime,
            enabledToTime,
            notes,
            isEnabled
        })
        this.post(`/${organisationId}/suspensions`, body, onSuccess, onError, token)
    },

    editSuspension(onSuccess, onError, suspensionId, name, startDate, endDate, monday, tuesday, wednesday, thursday, friday, saturday, sunday, enabledFromTime, enabledToTime, notes, isEnabled, organisationId, token) {
        const body = JSON.stringify({
            name,
            startDate,
            endDate,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            enabledFromTime,
            enabledToTime,
            notes,
            isEnabled
        })
        this.put(`/${organisationId}/suspensions/${suspensionId}`, body, onSuccess, onError, token)
    },

    deleteSuspension(onSuccess, onError, suspensionId, organisationId, token) {
        this.delete(`/${organisationId}/suspensions/${suspensionId}`, onSuccess, onError, token)
    },

    copySuspension(onSuccess, onError, suspensionId, name, organisationId, token) {
        this.post(`/${organisationId}/suspensions/${suspensionId}/copy`, JSON.stringify({name}), onSuccess, onError, token)
    },

    enableSuspensionSites(onSuccess, onError, suspensionId, siteIds, organisationId, token) {
        this.patch(`/${organisationId}/suspensions/${suspensionId}/sites/attach`, JSON.stringify({siteIds}), onSuccess, onError, token)
    },

    detachSuspensionSites(onSuccess, onError, suspensionId, siteIds, organisationId, token) {
        this.patch(`/${organisationId}/suspensions/${suspensionId}/sites/detach`, JSON.stringify({siteIds}), onSuccess, onError, token)
    },

    userAcceptTerms(onSuccess, onError, token) {
        this.post("/user/agreement", null, onSuccess, onError, token)
    },

    searchAuditLog(onSuccess, onError, pageNumber, pageSize, query, userId, from, to, entity, action, organisationId, token) {
        const body = JSON.stringify({ pageNumber, pageSize, query, userId, from, to, entity, action })
        if (_auditLogAbortController) {
            _auditLogAbortController.abort()
        }
        _auditLogAbortController = new AbortController();

        this.post(`/${ organisationId }/audit-logs/search`, body, onSuccess, onError, token, _auditLogAbortController.signal)
    },

    getAuditLogEntities(onSuccess, onError, organisationId, token) {
        this.get(`/${ organisationId }/audit-logs/entities`, onSuccess, onError, token)
    },

    getAuditLogActions(onSuccess, onError, organisationId, token) {
        this.get(`/${ organisationId }/audit-logs/actions`, onSuccess, onError, token)
    },

    userLogin(onSuccess, onError, organisationId, token) {
        this.post(`/user/login`, JSON.stringify({organisationId}), onSuccess, onError, token)
    },

    userLogout(onSuccess, onError, organisationId, token) {
        this.post(`/user/logout`, JSON.stringify({organisationId}), onSuccess, onError, token)
    },

    getAllSiteVariableAnprRanges(onSuccess, onError, organisationId, token) {
        this.get(`/${organisationId}/sites/variable-anpr`, onSuccess, onError, token)
    },

    getSiteVariableAnprRanges(onSuccess, onError, siteId, organisationId, token) {
        this.get(`/${organisationId}/sites/${siteId}/variable-anpr`, onSuccess, onError, token)
    },

    getSiteVariableAnprRange(onSuccess, onError, siteId, variableAnprRangeId, organisationId, token) {
        this.get(`/${organisationId}/sites/${siteId}/variable-anpr/${variableAnprRangeId}`, onSuccess, onError, token)
    },

    addSiteVariableAnprRange(onSuccess, onError,
                             name, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday,
                             isNonEnforcement, isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes,
                             overstayContraventionId, shortReturnContraventionId, failedToMakePaymentContraventionId,
                             allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId,
                             isEnabled,
                             freeParkingMinutes,
                             siteId, organisationId, token) {
        const body = JSON.stringify({
            name, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday, isNonEnforcement,
            isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes,
            overstayContraventionId, shortReturnContraventionId, failedToMakePaymentContraventionId,
            allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId,
            isEnabled,
            freeParkingMinutes,
        })
        this.post(`/${organisationId}/sites/${siteId}/variable-anpr`, body, onSuccess, onError, token)
    },

    editSiteVariableAnprRange(onSuccess, onError,
                             name, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday,
                             isNonEnforcement, isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes,
                             overstayContraventionId, shortReturnContraventionId, failedToMakePaymentContraventionId,
                             allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId,
                             isEnabled,
                             freeParkingMinutes,
                             variableAnprRangeId,
                             siteId, organisationId, token) {
        const body = JSON.stringify({
            name, startDate, endDate, enabledFromTime, enabledToTime, monday, tuesday, wednesday, thursday, friday, saturday, sunday, isNonEnforcement,
            isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes,
            overstayContraventionId, shortReturnContraventionId, failedToMakePaymentContraventionId,
            allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId,
            isEnabled,
            freeParkingMinutes
        })
        this.put(`/${organisationId}/sites/${siteId}/variable-anpr/${variableAnprRangeId}`, body, onSuccess, onError, token)
    },

    deleteSiteVariableAnprRange(onSuccess, onError, siteId, variableAnprRangeId, organisationId, token) {
        this.delete(`/${organisationId}/sites/${siteId}/variable-anpr/${variableAnprRangeId}`, onSuccess, onError, token)
    },

    downloadPostageCertificate(onSuccess, onError, letterId, organisationId, token ) {

        let filename;

        fetch(baseUrl + `/${organisationId}/letters/${letterId}/certificate`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + token,
                responseType: 'blob'
            }
        })
            .then(function (response) {
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json().then(data => Promise.reject(data));
                } else {
                    let contentDisposition = response.headers.get("Content-Disposition");

                    if (contentDisposition) {
                        let contentDispositionParts = contentDisposition.split(";");
                        let filenameElement = contentDispositionParts.find(x => x.indexOf("filename=") > 0);

                        if (filenameElement) {
                            filename = filenameElement.split("=")[1];
                        }
                    }
                    return response.blob();
                }
            })
            .then(function (blob) {
                if (onSuccess) {
                    onSuccess(blob, filename);
                }
            })
            .catch((error) => {
                if (onError) {
                    onError(error);
                }
            });
    }
}
var _previewAbortController = null;
var _dashSearchAbortController = null;
var _cameraDataAbortController = null;
var _paymentsDataAbortController = null;
var _pcnPaymentsDataAbortController = null;
var _kadoeDataAbortController = null;
var _lettersDataAbortController = null;
var _emailsDataAbortController = null;
var _allowListAbortController = null;
var _disallowListAbortController = null;
var _cancellationsReportAbortController = null;
var _voidsReportAbortController = null;
var _appealsReportAbortController = null;
var _pcnsPaidReportAbortController = null;
var _pcnsIssuedReportAbortController = null;
var _exportBreachesReportAbortController = null;
var _tolReportAbortController = null;
var _dataStorageReportAbortController = null;
var _vehicleAnalyticsAbortController = null;
var _debtRecoveryReportAbortController = null;
var _suspensionsAbortController = null;
var _auditLogAbortController = null;
var _averageStayAbortController = null;
var _dailyTotalsAbortController = null;
var _parkingDurationsAbortController = null;
var _contraventionsAbortController = null;
var _breachesReportAbortController = null;